import { r as registerInstance, h, g as getElement, c as createEvent, H as Host, F as Fragment } from './index-16dc7dde.js';
import { g as getMyProductsFromConnector } from './utils-62e3520b.js';
import { b as isProductInMyProducts, c as isProductGroupInMyProducts } from './utils-c23b708f.js';
import { i as isAppRoutingEnabled, g as getIsCustomAddToCartEnabled, b as getIsProductsInCustomCart, c as getIsCustomAddToFavoritesEnabled, e as getIsProductsInCustomFavorites, a as getCustomAddToCartSettings, d as getCustomAddToFavoritesSettings, n as navigateWithRouter, f as getIsCustomPriceEnabled, h as getCustomPrice } from './utils-60b2d521.js';
import { m as myProductsResponseStatus, o as ETabType, E as EAvailabilityType, a as EApcButtonType, h as PRIMARY_BUTTONS, i as SECONDARY_BUTTONS, x as APC_PRIMARY_BUTTONS, y as TABS_ORDER } from './request.constants-deb285e0.js';
import { i as isV3 } from './lookups-705fb53e.js';
import { p as parseCommonURLToRouterParts } from './url-parser-fe899a81.js';
import { i as isAnalyticsEnabled } from './helpers-71d81730.js';
import { P as PesRoute } from './pes-route-63457678.js';
import { f as favoriteButtonSizes } from './constants-3993c815.js';
import { b as buildCTAClickEvent, s as sendAnalytics } from './utils-f77f34ae.js';
import { j as join } from './path-9b025204.js';
import { s as send, t as virtualPageRelatedProductsEvent, h as productVariantsClickEvent, y as viewExternalPartnerLink } from './send-33ade633.js';
import { g as getApcCta, f as formCtaUrl, b as availabilityUrl, c as getAvailabilityInfo } from './api-413e09d4.js';
import { y as isBrowser, a as isMobile, F as html2plain } from './utils-15ad90ec.js';
import { i as isObject_1 } from './isObject-33fa1780.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { i as isNil_1, o as omitBy_1 } from './omitBy-fb73ffc4.js';
import { f as format } from './currency-b61904e0.js';
import { f as findProductFeedMinimalPrice, a as applyPriceTemplate, w as weeePricesToTextArray } from './price-9a41672f.js';
import { b as getDownloadButtonIcon, g as getDownloadButtonLabel } from './utils-e67addce.js';
import { p as pesIconSizes, a as pesIconMirrorDirection } from './constants-e9ddcc22.js';
import { L as LINK_TYPES, I as ICONS_BY_TYPE, T as TARGET_BY_TYPE } from './constants-ad5439d0.js';
import { c as classnames } from './index-136476ff.js';
import { i as isWebkitLineClampSupports } from './style.utils-d5f132da.js';
import { S as Se360widget, a as Se3dWidget } from './se-widgets-9d9747f6.js';
import { c as createSlides, M as MAX_PDP_WIDTH, Z as ZOOM_AREA_WIDTH, g as getUserSessionLoggedInValue } from './constants-31cd6520.js';
import { p as pesCatalogPageTypes } from './pes-router-store-1a105b49.js';
import { P as PesProductLink } from './pes-product-link-b5153381.js';
import { a as setTabActive } from './stickyBar.utils-09e3b4ce.js';
import { _ as _baseFlatten } from './_baseFlatten-2670ede5.js';
import { _ as _arrayMap } from './toString-da636857.js';
import { b as _baseGet, i as identity_1, e as eq_1 } from './identity-6651b537.js';
import { _ as _baseIteratee } from './_baseIteratee-506bcd8a.js';
import { _ as _baseMap } from './flatMap-bcae5f36.js';
import { a as isArray_1, k as _baseUnary, i as isArrayLike_1 } from './isTypedArray-dfccd669.js';
import { i as isSymbol_1 } from './isSymbol-45bfef0c.js';
import { a as _setToString, b as _overRest } from './_flatRest-49cdf089.js';
import { _ as _isIndex } from './_isIndex-af307327.js';
import { E as ExternalUrlConfigAction, g as generateExternalURL } from './utils-2361a8f1.js';
import { c as checkForLongWordInString, b as checkForShowMore } from './utils-48a92926.js';
import './noop-9247c8ef.js';
import './promise-74c80706.js';
import './analytics-765d4daf.js';
import './_commonjsHelpers-ba3f0406.js';
import './utils-913bdf8a.js';
import './http-fdc7ba18.js';
import './controller-0b53c447.js';
import './format-string-a043c0ab.js';
import './tslib.es6-2af8cb53.js';
import './toNumber-5000b45d.js';
import './parsers-e38ff6a5.js';
import './_basePickBy-9e484e47.js';
import './_assignValue-8e900715.js';
import './_getAllKeysIn-8178afb2.js';
import './_Uint8Array-2e849395.js';
import './_baseTimes-db8626dd.js';
import './index-634d378a.js';
import './ResizeObserver-f193871f.js';
import './hasIn-6ce0da41.js';
import './pick-bfea8c03.js';
import './types-aae419ee.js';

const additionalInfoCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.additional-info{color:#333333}.additional-info__title{color:#626469;font-size:0.875rem}.additional-info__label{font-size:0.875rem;font-weight:700}.additional-info__format-value{text-transform:uppercase}.additional-info ul{margin:0;padding:0;list-style:none}.additional-info li{font-size:0.875rem;margin-top:16px}.additional-info span{line-height:1.25rem}";

let AdditionalInfo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "additional-info" }, h("div", { class: "additional-info__title" }, h("span", null, this.title), this.version && this.labels && (h("span", null, ` (${this.labels.versionLabel} ${this.version})`))), this.labels && (h("ul", null, this.os && (h("li", null, h("span", { class: "additional-info__label" }, this.labels.operatingSystemsLabel, ":\u00A0"), h("span", null, this.os))), this.format && (h("li", null, h("span", { class: "additional-info__label" }, this.labels.formatLabel, ":\u00A0"), h("span", { class: "additional-info__format-value" }, this.format))), this.size && (h("li", null, h("span", { class: "additional-info__label" }, this.labels.sizeLabel, ":\u00A0"), h("span", null, this.size))), this.date && (h("li", null, h("span", { class: "additional-info__label" }, this.labels.dateLabel, ":\u00A0"), h("span", null, this.date))), this.language && (h("li", null, h("span", { class: "additional-info__label" }, this.labels.languageLabel, ":\u00A0"), h("span", null, this.language)))))));
  }
  get el() { return getElement(this); }
};
AdditionalInfo.style = additionalInfoCss;

const alternativesCss = ":host{display:block}.alternatives__body{border:1px solid #e7e6e6}@media screen and (min-width: 980px){.alternatives__body{padding:16px 0}}@media screen and (max-width: 979px){.alternatives__body{padding:15px 0 0}}.alternatives__header{color:#333333;font-size:0.875rem;line-height:1rem;margin:0 0 10px}pes-alternatives-item:not(:first-child){border-top:1px solid #e7e6e6}@media screen and (max-width: 979px){pes-alternatives-item:not(:first-child){padding-top:25px}}@media screen and (min-width: 980px){pes-alternatives-item:not(:first-child){padding-top:15px}}@media screen and (min-width: 980px){pes-alternatives-item:not(:last-child){padding-bottom:20px}}.alternatives__not-found{font-size:0.875rem;line-height:1.25rem;color:#333333;padding:0 15px}.alternatives__not-found a{color:#42b4e6;text-decoration:none}.alternatives__not-found a:hover,.alternatives__not-found a:focus{text-decoration:underline}";

let PesAlternatives = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isExpanded = false;
    this.myProducts = [];
    this.isAlternativeInMyProducts = (alternative, myProducts) => {
      if ((myProducts === null || myProducts === void 0 ? void 0 : myProducts.length) === 0) {
        return false;
      }
      const product = { [alternative.skuId]: 1 };
      return isProductInMyProducts(product, myProducts);
    };
    this.getIsAlternativeInCart = (alternative) => {
      if (isAppRoutingEnabled()) {
        if (getIsCustomAddToCartEnabled()) {
          return getIsProductsInCustomCart([alternative.skuId]);
        }
        if (getIsCustomAddToFavoritesEnabled()) {
          return getIsProductsInCustomFavorites([alternative.skuId]);
        }
        return false;
      }
      return this.isAlternativeInMyProducts(alternative, this.myProducts);
    };
    this.getIsCTAsHidden = () => {
      if (isAppRoutingEnabled()) {
        return !(getIsCustomAddToCartEnabled() || getIsCustomAddToFavoritesEnabled());
      }
      return this.hideCtas;
    };
    this.getCTALabels = () => {
      if (isAppRoutingEnabled()) {
        if (getIsCustomAddToCartEnabled()) {
          return {
            addToCartLabel: getCustomAddToCartSettings().labels.addLabel,
            removeFromCartLabel: getCustomAddToCartSettings().labels.removeLabel,
          };
        }
        if (getIsCustomAddToFavoritesEnabled()) {
          return {
            addToCartLabel: getCustomAddToFavoritesSettings().labels.addLabel,
            removeFromCartLabel: getCustomAddToFavoritesSettings().labels.removeLabel,
          };
        }
        return {
          addToCartLabel: this.addToCartProductLabel,
          removeFromCartLabel: this.removeFromCartProductLabel,
        };
      }
      return {
        addToCartLabel: this.addToCartProductLabel,
        removeFromCartLabel: this.cartTransferEnabled
          ? this.addToCartProductLabel
          : this.removeFromCartProductLabel,
      };
    };
    this.getIsCartTransferEnabled = () => {
      if (isAppRoutingEnabled()) {
        return getIsCustomAddToCartEnabled();
      }
      return this.cartTransferEnabled;
    };
    this.renderAlternative = (alternative) => {
      const commonProps = {
        productId: this.productId,
        comment: alternative.externalComment,
      };
      const props = ((alternative) => {
        const labels = this.getCTALabels();
        const otherProps = Object.assign(Object.assign(Object.assign({}, commonProps), labels), { hasCTA: !this.getIsCTAsHidden(), inCart: this.getIsAlternativeInCart(alternative), isCartTransferEnabled: this.getIsCartTransferEnabled(), product: {
            [alternative.skuId]: 1,
          } });
        return Object.assign({}, otherProps);
      })(alternative);
      return (h("pes-alternatives-item", Object.assign({}, props, { header: alternative.skuId, imageURL: alternative.imageLink.url, imageTitle: alternative.imageLink.title, description: alternative.description, url: alternative.productUrl, key: alternative.skuId })));
    };
    this.renderNotFound = () => {
      var _a;
      if (!((_a = this.alternatives) === null || _a === void 0 ? void 0 : _a.length)) {
        return h("span", { class: "alternatives__not-found", innerHTML: this.alternativeAbsentLabel });
      }
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleShowMoreLessClicked(e) {
    e.stopPropagation();
    this.isExpanded = !this.isExpanded;
  }
  componentDidLoad() {
    getMyProductsFromConnector().then((res) => (this.myProducts = res));
  }
  render() {
    return (h("section", { class: "alternatives" }, this.header && h("h2", { class: "alternatives__header" }, this.header), h("div", { class: "alternatives__body" }, this.alternatives.map(this.renderAlternative), this.renderNotFound())));
  }
  get el() { return getElement(this); }
};
PesAlternatives.style = alternativesCss;

const alternativesItemCss = ":host{display:block}.alternative__control{font-size:0.75rem;flex:0 0 auto}@media screen and (max-width: 979px){.alternative__control{order:3;box-sizing:border-box;margin:15px -15px 0;padding:10px 15px;min-height:60px;display:flex;justify-content:center;align-items:center;border-top:1px solid #e7e6e6}}@media screen and (min-width: 980px){.alternative__control{line-height:1rem}:host(:not([dir=\"rtl\"])) .alternative__control{margin:0 0 0 auto}:host([dir=\"rtl\"]) .alternative__control{margin:0 auto 0 0}}.alternative__content{display:flex;flex:0 0 100%;padding:0 15px}@media screen and (min-width: 980px){.alternative__content{flex-wrap:wrap;align-items:start;flex-direction:row}}@media screen and (max-width: 979px){.alternative__content{flex-direction:column}}.alternative-item{display:flex;text-decoration:none;flex:0 0 100%}@media screen and (max-width: 979px){.alternative-item{position:relative}}.alternative-item__image{width:50px;height:50px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .alternative-item__image:not(:first-child){margin-left:5px}:host([dir=\"rtl\"]) .alternative-item__image:not(:first-child){margin-right:5px}}:host(:not([dir=\"rtl\"])) .alternative-item__body{margin-left:15px}:host([dir=\"rtl\"]) .alternative-item__body{margin-right:15px}.alternative-item__description{font-size:0.875rem;line-height:1.25rem;color:#333333;margin:0}@media screen and (min-width: 980px){.alternative-item:active .alternative-item__description,.alternative-item:hover .alternative-item__description{text-decoration:underline}}.alternative-item__comment{margin:0 0 20px;color:#626469;font-size:0.75rem}@media screen and (max-width: 979px){.alternative-item__comment{line-height:0.9375rem}}@media screen and (min-width: 980px){.alternative-item__comment{flex:1 1 80%}}.alternative-item__name{font-size:0.625rem;line-height:1.25rem;color:#626469}";

let AlternativesItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.ctaClick = createEvent(this, "ctaClick", 7);
    this.handleFavoritesButtonClick = (e) => {
      this.ctaClick.emit(buildCTAClickEvent(e, {
        isCartTransferEnabled: this.isCartTransferEnabled,
        inCart: this.inCart,
        id: Object.keys(this.product)[0],
        quantity: Object.values(this.product)[0],
        onFinish: (result) => {
          if ((result === null || result === void 0 ? void 0 : result.status) === myProductsResponseStatus.SUCCESS) {
            this.inCart = !this.inCart;
            if (isAnalyticsEnabled()) {
              sendAnalytics(result, this.productId, this.product, true);
            }
          }
        },
      }));
    };
    this.linkClickHandler = (event) => {
      if (isAppRoutingEnabled()) {
        event.preventDefault();
        navigateWithRouter(this.route, event.currentTarget);
      }
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    this.mediaQuery = window.matchMedia('(max-width: 979px)');
    this.isMobile = this.mediaQuery.matches;
    this.mediaQuery.addEventListener('change', (e) => {
      this.isMobile = e.matches;
    });
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.url);
      this.route = new PesRoute({ page: pageType, pageId });
      this.url = this.route.url;
    }
  }
  render() {
    return (h("div", { class: "alternative__content" }, this.comment && h("p", { class: "alternative-item__comment" }, this.comment), this.hasCTA && (h("div", { class: "alternative__control" }, h("pes-favorites-button", { class: "alternative__button", size: this.isMobile ? favoriteButtonSizes.MD : favoriteButtonSizes.SM, addIcon: this.isCartTransferEnabled ? 'segment_retail' : 'star_stroke', removeIcon: this.isCartTransferEnabled ? 'segment_retail' : 'star_plain', addLabel: this.addToCartLabel, removeLabel: this.removeFromCartLabel, isInList: this.inCart, onClick: this.handleFavoritesButtonClick }))), h("a", { href: this.url, class: "alternative-item", onClick: this.linkClickHandler }, h("pes-lazy-img", { src: this.imageURL, alt: this.imageTitle, class: "alternative-item__image" }), h("div", { class: "alternative-item__body" }, h("div", { class: "alternative-item__description" }, this.description), h("div", { class: "alternative-item__name", innerHTML: this.header })))));
  }
  get el() { return getElement(this); }
};
AlternativesItem.style = alternativesItemCss;

const BULLET_POINT_TYPES = {
  enabled: 'enabled',
  disabled: 'disabled',
};

const bulletPointsCss = ".bullet-points{padding-top:24px;padding-bottom:32px}@media screen and (min-width: 720px){.bullet-points{padding-bottom:24px}}.bullet-item{display:flex;align-items:flex-start}.bullet-item:not(:last-child){margin-bottom:16px}.bullet-item__icon{width:14px;height:16px;flex-shrink:0;overflow:hidden}:host(:not([dir=\"rtl\"])) .bullet-item__icon{margin-right:8px}:host([dir=\"rtl\"]) .bullet-item__icon{margin-left:8px}.bullet-item--enabled .icon{position:relative;top:-5px;color:#3dcd58}:host(:not([dir=\"rtl\"])) .bullet-item--enabled .icon{left:-9px}:host([dir=\"rtl\"]) .bullet-item--enabled .icon{right:-9px}.bullet-item--disabled .icon{position:relative;color:#b10043}:host(:not([dir=\"rtl\"])) .bullet-item--disabled .icon{left:-2px}:host([dir=\"rtl\"]) .bullet-item--disabled .icon{right:-2px}.bullet-item__label{font-size:14px;line-height:20px;color:#626469}.bullet-item__link{text-decoration:none;outline:none;color:#42b4e6;cursor:pointer}.bullet-item__link:hover{text-decoration:underline}";

let BulletPoints = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.tabClicked = createEvent(this, "tabClicked", 7);
    this.getTabType = (hash) => {
      switch (hash) {
        case '#ecostruxure':
          return ETabType.ECOSTRUXURE;
        case '#sustainability':
          return ETabType.SUSTAINABILITY;
        default:
          return null;
      }
    };
    this.linkClickHandler = (e, link) => {
      if (link.startsWith('#')) {
        e.preventDefault();
        this.tabClicked.emit({
          type: this.getTabType(link),
          title: null,
        });
      }
    };
    this.onRelatedProductHandler = (item) => {
      this.selectedBulletedPOint = item;
      this.openModal = true;
      if (isAnalyticsEnabled()) {
        send(virtualPageRelatedProductsEvent, { relatedSectionId: item.relatedProductGroup.groupId });
      }
    };
    this.renderLink = (linkData, _showModel = false, item) => {
      const { label, link } = linkData;
      if (!_showModel) {
        return (h("a", { class: "bullet-item__link", href: link, onClick: (e) => {
            this.linkClickHandler(e, link);
          } }, label));
      }
      return (h("a", { class: "bullet-item__link", onClick: () => {
          this.onRelatedProductHandler(item);
        }, innerHTML: label }));
    };
    this.renderBulletPoint = (item) => {
      const { bulletPointType, bulletPointText, bulletPointLink, showModal } = item;
      const { enabled } = BULLET_POINT_TYPES;
      const hasBulletPointLink = (bulletPointLink === null || bulletPointLink === void 0 ? void 0 : bulletPointLink.link) && (bulletPointLink === null || bulletPointLink === void 0 ? void 0 : bulletPointLink.label);
      const hashLink = hasBulletPointLink && (bulletPointLink === null || bulletPointLink === void 0 ? void 0 : bulletPointLink.link.startsWith('#')) ? bulletPointLink.link : null;
      return (h("div", { class: `bullet-item bullet-item--${bulletPointType}`, "data-da-autotest-id": hashLink }, h("div", { class: "bullet-item__icon" }, (h("pes-icon", { class: "icon", size: bulletPointType === enabled ? 'medium' : 'micro' }, bulletPointType === enabled ? 'notification_ok' : 'notification_error_plain'))), h("div", { class: "bullet-item__label" }, this.renderBulletPointText(bulletPointText, showModal, item), hasBulletPointLink && ' ', hasBulletPointLink && this.renderLink(bulletPointLink))));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  dialogCloseHandler() {
    this.openModal = false;
  }
  componentWillLoad() {
    if (window.isApc) {
      this.makeInitialRequests();
    }
  }
  componentDidLoad() {
    getMyProductsFromConnector().then((res) => (this.myProducts = res));
  }
  async makeInitialRequests() {
    try {
      const endPoint = isV3() ? '/products-cta' : '/product/api/commerce-api/cta';
      await this.requestApcCta(endPoint);
      await this.requestProductAvailabilityInfo();
    }
    catch (e) {
      throw new Error(e);
    }
  }
  async requestApcCta(apcCtaUrl) {
    const locale = document.querySelector('body').getAttribute('locale');
    const [languageCode, countryCode] = locale.split('_');
    if (isV3()) {
      const params = {
        countryCode,
        languageCode,
        productId: this.productId,
      };
      this.apcCta = await getApcCta(formCtaUrl(apcCtaUrl, params));
      return;
    }
    this.apcCta = await getApcCta(`/${countryCode.toLowerCase()}/${languageCode}${apcCtaUrl}`);
  }
  async requestProductAvailabilityInfo() {
    var _a, _b, _c;
    if ((_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.urls.apcHost) {
      const requestUrl = availabilityUrl((_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.apcHost, this.getLocaleCodes(), this.getRelatedProductIds());
      this.productAvailabilityInfo = await getAvailabilityInfo(requestUrl);
    }
  }
  getLocaleCodes() {
    const locale = document.querySelector('body').getAttribute('locale');
    const [languageCode, contryCode] = locale.split('_');
    return contryCode && languageCode
      ? join('/', contryCode.toLowerCase(), languageCode.toLowerCase())
      : '';
  }
  getRelatedProductIds() {
    if (this.data.length) {
      const relatedProducts = this.data
        .map((group) => { var _a, _b; return (_b = (_a = group === null || group === void 0 ? void 0 : group.relatedProductGroup) === null || _a === void 0 ? void 0 : _a.products) === null || _b === void 0 ? void 0 : _b.map((product) => product.product.name); })
        .join('%7C')
        .replace(/,/g, '%7C');
      return relatedProducts;
    }
  }
  renderBulletPointText(bulletPointText, showModal, item) {
    if (bulletPointText.indexOf('<a>') === -1 && bulletPointText.indexOf('&lt;a&gt;') === -1) {
      return bulletPointText;
    }
    const stringVal = bulletPointText;
    let regLt = /</g;
    let regGt = />/g;
    if (bulletPointText.indexOf('&lt;a&gt;') !== -1) {
      regLt = /&lt;/g;
      regGt = /&gt;/g;
    }
    const replacedVal = stringVal.replace(regLt, '#').replace(regGt, '#');
    const obj = replacedVal.split('#a#');
    const finalArr = [];
    obj.forEach((_item) => {
      if (_item) {
        if (_item.indexOf('#/a#') > -1) {
          const textVal = _item.split('#/a#');
          finalArr.push({ text: textVal[0], type: 'link' });
          if (textVal.length > 1 && textVal[1] !== '') {
            finalArr.push({ text: textVal[1], type: 'span' });
          }
        }
        else {
          finalArr.push({ text: _item, type: 'span' });
        }
      }
    });
    return (h("span", null, finalArr.map((itemLinks) => {
      if (itemLinks.type === 'link') {
        return this.renderLink({ label: itemLinks.text, link: '#' }, showModal, item);
      }
      return itemLinks.text;
    })));
  }
  renderModal() {
    return (h("pes-related-products-dialog", { isOpen: this.openModal, products: this.selectedBulletedPOint.relatedProductGroup.products, header: this.selectedBulletedPOint.relatedProductGroup.popupLabel, cartTransferEnabled: this.cartTransferEnabled, myProducts: this.myProducts, groupId: this.selectedBulletedPOint.relatedProductGroup.groupId, productId: this.productId, key: this.selectedBulletedPOint.relatedProductGroup.groupId, apcCta: this.apcCta, productAvailabilityInfo: this.productAvailabilityInfo }));
  }
  render() {
    var _a;
    return ((_a = this.data) === null || _a === void 0 ? void 0 : _a.length) ? (h(Host, { class: "bullet-points" }, this.data.map(this.renderBulletPoint), this.openModal && this.renderModal())) : null;
  }
  get el() { return getElement(this); }
};
BulletPoints.style = bulletPointsCss;

/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

var isNull_1 = isNull;

const ctaAreaContainerCss = ":host{display:block}@media screen and (min-width: 980px){:host{border-top:1px solid #e7e6e6}}";

let CtaAreaContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.buyOnlineClick = createEvent(this, "buyOnlineClick", 7);
    this.notifyButtonDidClick = createEvent(this, "notifyButtonDidClick", 7);
    this.promotedButtonDidClick = createEvent(this, "promotedButtonDidClick", 7);
    this.downloadButtonDidClick = createEvent(this, "downloadButtonDidClick", 7);
    this.addToCartButtonDidClick = createEvent(this, "addToCartButtonDidClick", 7);
    this.apcCtaButtonDidClick = createEvent(this, "apcCtaButtonDidClick", 7);
    this.showFavorites = false;
    this.showSkeleton = false;
    this.isInMyProductsList = false;
    this.isInFavorites = false;
    this.isPBS = false;
    this.addToCartButtonRendered = false;
    this.getProductFeedMinimalPriceText = () => {
      const product = this.getCurrentProductFeed();
      const price = findProductFeedMinimalPrice(product);
      const { countryLanguageCode, priceTemplate } = this.commerceConnectorSettings.options;
      if (!price || !countryLanguageCode || !priceTemplate) {
        return null;
      }
      const formattedPrice = format(price, { locale: countryLanguageCode });
      return applyPriceTemplate(formattedPrice, priceTemplate);
    };
    this.handleClick = (event) => {
      this.apcCtaButtonDidClick.emit({
        initialEvent: event,
        buttonType: this.getButtonType(),
        isStickyBar: this.isStickyBar,
      });
    };
    this.getButtonType = () => {
      var _a, _b;
      const availabilityType = ((_b = (_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.availability) === null || _b === void 0 ? void 0 : _b[this.productId]) || null;
      switch (availabilityType) {
        case EAvailabilityType.ADD_TO_CART:
        case EAvailabilityType.PURCHASE_CD:
          return EApcButtonType.ADD_TO_CART;
      }
    };
    this.getCtaButtonType = (primaryButtonsArray) => {
      let buttonType = this.findButtonType(primaryButtonsArray);
      const { enableProductSelectorButton } = this.productSelectorConfig || {};
      if (enableProductSelectorButton
        && !!this.productSelectorConfig
        && !!this.rangeSelectorConfig
        && (primaryButtonsArray.indexOf(buttonType)
          > primaryButtonsArray.indexOf("PRODUCT_SELECTOR_BUTTON")
          || primaryButtonsArray.indexOf(buttonType) === -1)) {
        buttonType = "PRODUCT_SELECTOR_BUTTON";
      }
      return buttonType;
    };
    this.getPrices = () => {
      var _a, _b, _c;
      const { priceLabel, previousPriceValue, VATInclused, previousPrice, activePrice, activePriceNoTax, activePriceValue, } = (_c = (_b = (_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.prices) === null || _b === void 0 ? void 0 : _b[this.productId]) !== null && _c !== void 0 ? _c : {};
      return {
        priceLabel: priceLabel || null,
        previousPriceValue: previousPriceValue || null,
        VATInclused: VATInclused || null,
        previousPrice: previousPrice || null,
        activePrice: activePrice || null,
        activePriceNoTax: activePriceNoTax || null,
        activePriceValue: activePriceValue || null,
      };
    };
  }
  getPriceTextContent() {
    if (getIsCustomPriceEnabled() && !!getCustomPrice()) {
      return this.getCustomPriceText(getCustomPrice());
    }
    if (this.showPartnerPrice()) {
      return this.getProductFeedMinimalPriceText();
    }
    return this.getProductPriceText();
  }
  showPartnerPrice() {
    var _a, _b, _c;
    return ((_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.enablePrice) && ((_c = this.productsFeed) === null || _c === void 0 ? void 0 : _c.length) > 0;
  }
  isPriceAvailable() {
    var _a, _b;
    return !!(((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.price) && ((_b = this.ctaData) === null || _b === void 0 ? void 0 : _b.currency));
  }
  getProductPriceText() {
    return this.isPriceAvailable() ? `${this.ctaData.price}&nbsp;${this.ctaData.currency}` : null;
  }
  getCustomPriceText(customPrice) {
    return `${customPrice.price}&nbsp;${customPrice.currencyCode}`;
  }
  getCurrentProductFeed() {
    var _a;
    return (_a = this.productsFeed) === null || _a === void 0 ? void 0 : _a.find((product) => (product === null || product === void 0 ? void 0 : product.ProductId) === this.productId);
  }
  hasTooltip() {
    var _a;
    return !this.showPartnerPrice() && !isEmpty_1((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.weeePrices);
  }
  renderWeeePrices() {
    if (!this.hasTooltip()) {
      return null;
    }
    return weeePricesToTextArray(this.ctaData.weeePrices).map((text) => h("div", { innerHTML: text }));
  }
  findButtonType(buttonTypes) {
    return buttonTypes.find((type) => { var _a; return type in (((_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) || {}); });
  }
  renderSeButtonFactory(type, isSticky) {
    var _a, _b;
    const button = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b[type];
    if (!button) {
      if (type === "PRODUCT_SELECTOR_BUTTON") {
        return this.renderProductSelectorButton("PRODUCT_SELECTOR_BUTTON");
      }
      return null;
    }
    switch (type) {
      case "BUY_ONLINE_BUTTON_REGULAR":
      case "BUY_ONLINE_BUTTON_APC":
        return this.renderBuyOnlineButton();
      case "NOTIFY_ME_BUTTON":
        return this.renderNotifyMeButton(button);
      case "ADD_TO_CART_BUTTON":
        return this.renderAddToCartButton(button, isSticky);
      case "DOWNLOAD_BUTTON":
        return this.renderDownloadButton(button);
      case "PROMOTED_BUTTON":
        return this.renderPromotedButton(button);
      default:
        return null;
    }
  }
  renderBuyOnlineButton() {
    var _a, _b, _c, _d;
    let buttonProps = {};
    const regularButton = (_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.BUY_ONLINE_BUTTON_REGULAR;
    const apcButton = (_d = (_c = this.ctaData) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d.BUY_ONLINE_BUTTON_APC;
    buttonProps = this.buildBuyOnlineButton(buttonProps, regularButton, apcButton);
    if (buttonProps.label) {
      buttonProps.onClick = () => ((buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.link) ? this.buyOnlineClick.emit(buttonProps.link) : this.buyOnlineClick.emit());
    }
    return isEmpty_1(buttonProps) ? null : buttonProps;
  }
  buildBuyOnlineButton(buttonProps, regularButton, apcButton) {
    if (regularButton && this.showBuyOnline) {
      buttonProps.label = regularButton.labels.defaultLabel;
      buttonProps.dataset = {
        autotestId: "BUY_ONLINE_BUTTON_REGULAR".toLowerCase(),
      };
    }
    else if (apcButton === null || apcButton === void 0 ? void 0 : apcButton.link) {
      buttonProps.label = apcButton.labels.defaultLabel;
      buttonProps.icon = 'action_new_window';
      buttonProps.iconPosition = 'end';
      buttonProps.link = apcButton.link;
      buttonProps.dataset = {
        autotestId: "BUY_ONLINE_BUTTON_APC".toLowerCase(),
      };
    }
    return buttonProps;
  }
  renderAddToCartButton(button, isSticky) {
    this.addToCartButtonRendered = true;
    return {
      type: 'secondary',
      icon: 'segment_retail',
      label: button.labels.defaultLabel,
      onClick: (e) => {
        this.addToCartButtonDidClick.emit({ initialEvent: e, isStickyBar: isSticky });
      },
      dataset: {
        autotestId: "ADD_TO_CART_BUTTON".toLowerCase(),
      },
    };
  }
  renderNotifyMeButton(button) {
    return {
      label: button.labels.defaultLabel,
      onClick: () => this.notifyButtonDidClick.emit(button.link),
      dataset: {
        autotestId: "NOTIFY_ME_BUTTON".toLowerCase(),
      },
    };
  }
  renderDownloadButton(button) {
    return {
      icon: getDownloadButtonIcon(this.softwareDocuments),
      iconPosition: 'end',
      label: getDownloadButtonLabel(this.softwareDocuments, button, this.downloadLabel),
      onClick: () => this.downloadButtonDidClick.emit(),
      dataset: {
        autotestId: "DOWNLOAD_BUTTON".toLowerCase(),
      },
    };
  }
  renderPrimaryButton(isSticky) {
    const buttonType = this.getCtaButtonType(PRIMARY_BUTTONS);
    return this.renderSeButtonFactory(buttonType, isSticky);
  }
  renderSecondaryButton(isSticky) {
    let buttonType;
    const { enableProductSelectorButton } = this.productSelectorConfig || {};
    const primaryBtnType = this.getCtaButtonType(PRIMARY_BUTTONS);
    if (enableProductSelectorButton && primaryBtnType === "NOTIFY_ME_BUTTON") {
      buttonType = "PRODUCT_SELECTOR_BUTTON";
    }
    else {
      buttonType = this.findButtonType(SECONDARY_BUTTONS);
    }
    return this.renderSeButtonFactory(buttonType, isSticky);
  }
  renderPromotedButton(button) {
    var _a;
    return {
      label: (_a = button === null || button === void 0 ? void 0 : button.labels) === null || _a === void 0 ? void 0 : _a.defaultLabel,
      onClick: () => this.promotedButtonDidClick.emit(button === null || button === void 0 ? void 0 : button.link),
      dataset: {
        autotestId: "PROMOTED_BUTTON".toLowerCase(),
      },
    };
  }
  renderProductSelectorButton(buttonType) {
    var _a;
    if (buttonType === "PRODUCT_SELECTOR_BUTTON"
      && this.showProductSelectorStatus.state === false) {
      return null;
    }
    return {
      label: (_a = this.productSelectorConfig) === null || _a === void 0 ? void 0 : _a.buttonlabel,
      onClick: () => { },
      icon: 'product_selector',
      iconPosition: 'start',
      dataset: {
        autotestId: buttonType.toLowerCase(),
      },
    };
  }
  addPromotedBtn(primary, secondary, promoted) {
    if (!primary && !secondary[0]) {
      primary = promoted;
    }
    else {
      secondary.push(promoted);
    }
    secondary = secondary.filter((item) => !isNil_1(item)).length ? secondary : null;
    return { primary, secondary };
  }
  mapCtaButtons(isSticky = false) {
    const initialPrimaryBtn = this.renderPrimaryButton(isSticky);
    let secondaryBtn = [this.renderSecondaryButton(isSticky)];
    const promotedBtn = this.renderSeButtonFactory("PROMOTED_BUTTON", isSticky);
    const primaryBtn = initialPrimaryBtn || secondaryBtn[0];
    secondaryBtn = !initialPrimaryBtn ? [null] : secondaryBtn;
    const { primary, secondary } = this.addPromotedBtn(primaryBtn, secondaryBtn, promotedBtn);
    return omitBy_1({
      primary,
      secondary,
    }, isNil_1);
  }
  getPriceFromLabel() {
    var _a, _b;
    return this.showPartnerPrice() ? (_b = (_a = this.commerceConnectorSettings) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.priceFrom : null;
  }
  isFavoritesAllowed(isSticky = false) {
    if (this.isApc || !isSticky) {
      return this.showFavorites;
    }
    return this.showFavorites && !this.addToCartButtonRendered;
  }
  buildEApcAddToCartButton(buttonType) {
    var _a, _b;
    const button = {};
    if (buttonType === EApcButtonType.ADD_TO_CART) {
      button.label = (_b = (_a = this.apcCta) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.addToCartButtonLabel;
      button.icon = 'segment_retail';
      button.iconPosition = 'start';
      button.dataset = {
        autotestId: EApcButtonType.ADD_TO_CART.toLowerCase(),
      };
    }
    button.onClick = (e) => this.handleClick(e);
    return button.label ? button : null;
  }
  buildECtaApcButton(ctaButtonType) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let button = {};
    switch (ctaButtonType) {
      case "NOTIFY_ME_BUTTON":
        const notifyButton = this.renderNotifyMeButton((_b = (_a = this.ctaData) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b["NOTIFY_ME_BUTTON"]);
        button = Object.assign(Object.assign({}, button), notifyButton);
        break;
      case "BUY_ONLINE_BUTTON_REGULAR":
        this.buildBuyOnlineButton(button, (_d = (_c = this.ctaData) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d["BUY_ONLINE_BUTTON_REGULAR"], {});
        button.type = 'secondary';
        button.onClick = () => this.buyOnlineClick.emit();
        break;
      case "DOWNLOAD_BUTTON":
        const downloadButton = this.renderDownloadButton((_f = (_e = this.ctaData) === null || _e === void 0 ? void 0 : _e.buttons) === null || _f === void 0 ? void 0 : _f["DOWNLOAD_BUTTON"]);
        button = Object.assign(Object.assign({}, button), downloadButton);
        break;
      case "PROMOTED_BUTTON":
        const promotedButton = this.renderPromotedButton((_h = (_g = this.ctaData) === null || _g === void 0 ? void 0 : _g.buttons) === null || _h === void 0 ? void 0 : _h["PROMOTED_BUTTON"]);
        button = Object.assign(Object.assign({}, button), promotedButton);
        break;
      case "PRODUCT_SELECTOR_BUTTON":
        const productSelectorButton = this.renderProductSelectorButton("PRODUCT_SELECTOR_BUTTON");
        button = Object.assign(Object.assign({}, button), productSelectorButton);
        break;
    }
    return button.label ? button : null;
  }
  renderApcButton() {
    const buttonType = this.getButtonType();
    const ctaButtonType = this.getCtaButtonType(APC_PRIMARY_BUTTONS);
    const eComAddToCartBtn = this.buildEApcAddToCartButton(buttonType);
    const eCtaBtn = this.buildECtaApcButton(ctaButtonType);
    let secondaryProductSelectorBtn;
    const { enableProductSelectorButton } = this.productSelectorConfig;
    if (enableProductSelectorButton && ctaButtonType === "NOTIFY_ME_BUTTON") {
      secondaryProductSelectorBtn = this.buildECtaApcButton("PRODUCT_SELECTOR_BUTTON");
    }
    const primaryBtn = isNull_1(eComAddToCartBtn) && !isNull_1(eCtaBtn) ? eCtaBtn : eComAddToCartBtn;
    const secondaryBtn = [
      (!isNull_1(eComAddToCartBtn) && !isNull_1(eCtaBtn) && eCtaBtn.type === 'secondary')
        || isNull_1(secondaryProductSelectorBtn)
        ? eCtaBtn
        : secondaryProductSelectorBtn,
    ];
    const promotedBtn = this.buildECtaApcButton("PROMOTED_BUTTON");
    const { primary, secondary } = this.addPromotedBtn(primaryBtn, secondaryBtn, promotedBtn);
    return omitBy_1({
      primary,
      secondary,
    }, isNil_1);
  }
  renderStickyCtaArea(buttonsForSticky, priceHTML, priceFromLabel, isInFavorites) {
    return (h("pes-cta-area-view-sticky", { imageUrl: this.imageUrl, imageTitle: this.imageTitle, priceHTML: priceHTML, tooltipHTML: this.renderWeeePrices(), buttons: buttonsForSticky, priceFromLabel: priceFromLabel, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed(true), isInFavorites: isInFavorites, rangeSelectorConfig: this.rangeSelectorConfig, productSelectorConfig: this.productSelectorConfig, showProductSelectorStatus: this.showProductSelectorStatus }));
  }
  get secondaryPrice() {
    if (getIsCustomPriceEnabled() && !!getCustomPrice()) {
      if (this.showPartnerPrice()) {
        return this.getProductFeedMinimalPriceText();
      }
      return this.getProductPriceText();
    }
  }
  render() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let buttons;
    let buttonsForSticky;
    let prices;
    let previousPriceHTML;
    let inStockLabel;
    let vatLabel;
    let resellerLabel;
    let priceHTML;
    let materialPriceGroup;
    let priceFromLabel;
    let showCompare;
    let isInFavorites;
    if (this.isApc) {
      prices = this.getPrices();
      priceHTML = prices.activePrice;
      buttons = this.renderApcButton();
      buttonsForSticky = this.renderApcButton();
      previousPriceHTML = prices.previousPrice;
      inStockLabel = ((_a = this.availabilityInfo) === null || _a === void 0 ? void 0 : _a.availability[this.productId]) === EAvailabilityType.ADD_TO_CART
        ? (_c = (_b = this.apcCta) === null || _b === void 0 ? void 0 : _b.labels) === null || _c === void 0 ? void 0 : _c.inStockLabel
        : '';
      vatLabel = (prices === null || prices === void 0 ? void 0 : prices.VATInclused) && ((_e = (_d = this.apcCta) === null || _d === void 0 ? void 0 : _d.labels) === null || _e === void 0 ? void 0 : _e.vatLabel);
      resellerLabel = prices.priceLabel;
      isInFavorites = this.isInFavorites;
      showCompare = this.showCompare;
    }
    else {
      priceHTML = this.getPriceTextContent();
      buttons = this.mapCtaButtons();
      buttonsForSticky = this.mapCtaButtons(true);
      materialPriceGroup = this.materialPriceGroup;
      priceFromLabel = this.getPriceFromLabel();
      showCompare = this.showCompare;
      isInFavorites = this.isInMyProductsList;
    }
    if (this.isStickyBar) {
      return this.renderStickyCtaArea(buttonsForSticky, priceHTML, priceFromLabel, isInFavorites);
    }
    return (h(Host, null, h("pes-cta-area-view", { productId: this.productId, priceHTML: priceHTML, secondaryPrice: this.secondaryPrice, tooltipHTML: this.renderWeeePrices(), previousPriceHTML: previousPriceHTML, inStockLabel: inStockLabel, vatLabel: vatLabel, resellerLabel: resellerLabel, buttons: buttons, showSkeleton: this.showSkeleton, materialPriceGroup: materialPriceGroup, priceFromLabel: priceFromLabel, compareLabel: this.compareLabel, addedToCartLabel: (_h = (_g = (_f = this.ctaData) === null || _f === void 0 ? void 0 : _f.labels) === null || _g === void 0 ? void 0 : _g.addedToCart) !== null && _h !== void 0 ? _h : null, showAddedToCartLabel: this.addToCartButtonRendered && this.isInMyProductsList, isInFavorites: isInFavorites, showCompare: showCompare, addToMyProductsLabel: this.addToMyProductsLabel, removeFromMyProductsLabel: this.removeFromMyProductsLabel, showFavorites: this.isFavoritesAllowed(), rangeSelectorConfig: this.rangeSelectorConfig, productSelectorConfig: this.productSelectorConfig, showProductSelectorStatus: this.showProductSelectorStatus, circularEconomyInfo: this.circularEconomyInfo, prioritizeBuyNowButton: this.prioritizeBuyNowButton, countryCode: this.countryCode, localeCode: this.localeCode, isPBS: this.isPBS, shoppableRedirectionData: this.shoppableRedirectionData, productCR: this.productCR, shopSeLink: this.shopSeLink, showShopSeLoader: this.showShopSeLoader }, h("slot", { name: "discounted-price", slot: "discounted-price" }))));
  }
};
CtaAreaContainer.style = ctaAreaContainerCss;

const highlightedCharacteristicsCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.highlighted-characteristics{color:#626469}.highlighted-characteristics__item+.highlighted-characteristics__item{margin-top:16px}.highlighted-characteristics__with-label{font-size:0.875rem;font-weight:700}";

let HighlightedCharacteristics = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    var _a;
    const characteristics = (_a = this.highlightedCharacteristics) === null || _a === void 0 ? void 0 : _a.all;
    return (h("div", { class: "highlighted-characteristics" }, characteristics
      && characteristics.map((item) => {
        return (h("div", { class: "highlighted-characteristics__item highlighted-characteristics__with-label" }, `${item.label}: ${item.values.join(', ')}`));
      })));
  }
  get el() { return getElement(this); }
};
HighlightedCharacteristics.style = highlightedCharacteristicsCss;

const lifeCycleInfoCss = ".commercial-status{font-weight:normal;font-size:14px;line-height:1.4285714286}.commercial-status__title{margin-bottom:5px;font-weight:bold}.commercial-status__item{display:flex;align-items:center;margin-bottom:12px}.commercial-status__item:last-of-type{margin-bottom:0}:host(:not([dir=\"rtl\"])) .commercial-status__item-icon{margin-right:6px}:host([dir=\"rtl\"]) .commercial-status__item-icon{margin-left:6px}.commercial-status__content{display:flex}:host(:not([dir=\"rtl\"])) .commercial-status__content{margin-right:3px}:host([dir=\"rtl\"]) .commercial-status__content{margin-left:3px}.commercial-status__content-label{font-weight:bold}:host(:not([dir=\"rtl\"])) .commercial-status__content-date{margin-left:3px}:host([dir=\"rtl\"]) .commercial-status__content-date{margin-right:3px}.commercial-status__hint{cursor:default;color:#0f0f0f;padding:2px;list-style:none;font-size:14px;line-height:1.7857142857}:host(:not([dir=\"rtl\"])) .commercial-status__hint{text-align:left}:host([dir=\"rtl\"]) .commercial-status__hint{text-align:right}.commercial-status__hint li{list-style:none;padding-bottom:10px;font-weight:bold}.commercial-status__hint span{color:#0f0f0f}.commercial-status__hint p{margin:0;color:#0f0f0f;padding-top:10px;font-weight:normal}.commercial-status__hint a{cursor:pointer;display:initial;font-weight:normal;font-size:14px;color:#0087cd;text-decoration:none}.commercial-status__hint a:hover{text-decoration:underline}.commercial-status__hint-title{font-weight:bold}";

let LifeCycleInfo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  static getTooltipInnerHTML(tooltip) {
    const el = document.createElement('div');
    el.innerHTML = tooltip;
    const tooltipMessage = el.querySelector('ul');
    const messages = tooltipMessage === null || tooltipMessage === void 0 ? void 0 : tooltipMessage.querySelectorAll('li');
    messages === null || messages === void 0 ? void 0 : messages.forEach((li) => {
      li.setAttribute('style', 'font-weight: bold;');
      li.querySelector('p').setAttribute('style', 'font-weight: normal;');
    });
    return tooltipMessage === null || tooltipMessage === void 0 ? void 0 : tooltipMessage.innerHTML;
  }
  renderCommercialStatusInfo(info) {
    return [
      h("div", { class: "commercial-status__content" }, h("span", { class: "commercial-status__content-label", style: { color: this.productStatus.commercialColor } }, info.dateLabel), info.date && h("span", { class: "commercial-status__content-date" }, info.date)),
      info.tooltipMessage && isBrowser() && (h("pdp-icon-tooltip", { icon: "information_stroke", iconSize: "nano" }, h("ul", { class: "commercial-status__hint", innerHTML: LifeCycleInfo.getTooltipInnerHTML(info.tooltipMessage) }))),
    ];
  }
  renderCommercialStatusItem(item) {
    if (!item)
      return;
    return (h("div", { class: "commercial-status__item" }, (h("pes-icon", { size: pesIconSizes.MICRO, class: "commercial-status__item-icon", style: { color: this.productStatus.commercialColor } }, "notification_critical")), this.renderCommercialStatusInfo(item)));
  }
  render() {
    if (!this.productStatus) {
      return null;
    }
    const { sale, preSale, service } = this.productStatus;
    return ((sale || preSale || service) && (h(Host, { class: "subsection__item" }, h("div", { class: "commercial-status" }, this.renderCommercialStatusItem(sale), this.renderCommercialStatusItem(preSale), this.renderCommercialStatusItem(service)))));
  }
  get el() { return getElement(this); }
};
LifeCycleInfo.style = lifeCycleInfoCss;

const linksCss = ":host{display:block}@media screen and (max-width: 979px){.links{text-align:center}}@media screen and (max-width: 979px){.links__item{display:block;margin-bottom:16px}}@media screen and (min-width: 980px){.links__item{display:inline-block;margin-bottom:15px}:host(:not([dir=\"rtl\"])) .links__item{margin-right:24px}:host([dir=\"rtl\"]) .links__item{margin-left:24px}}.links__item:only-child,.links__item:last-child{margin:0}";

let Links = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "links" }, this.links
      && Object.entries(this.links).map(([type, link]) => {
        if (type === LINK_TYPES.REGISTER_TO_NEWSLETTER) {
          return (h("pes-label-link", { class: "links__item", label: link.labels.defaultLabel, anchor: this.isApcSite ? 'sdl-footer-apcemail' : 'sdl-footer-seemail', icon: ICONS_BY_TYPE[type] }));
        }
        return (h("pes-link", { class: "links__item", label: link.labels.defaultLabel, link: link.link, icon: ICONS_BY_TYPE[type], target: TARGET_BY_TYPE[type] }));
      })));
  }
  get el() { return getElement(this); }
};
Links.style = linksCss;

const mainProductInfoCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.main-product-info__description{margin:0;padding-bottom:6px;font-size:1.375rem;line-height:1.875rem;font-weight:bold}.main-product-info__bottom{display:flex;align-items:center;flex-wrap:wrap}.main-product-info__bottom-item{margin-top:8px}:host(:not([dir=\"rtl\"])) .main-product-info__bottom-item:not(:last-child){margin-right:16px}:host([dir=\"rtl\"]) .main-product-info__bottom-item:not(:last-child){margin-left:16px}.main-product-info__bottom-item--product-id{margin-bottom:0;color:#626469;font-size:0.875rem;font-weight:normal;line-height:1.25rem}.main-product-info__bottom-item--e-number{display:flex;font-weight:bold}";

let MainProductInfo = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    if (!this.productInfo) {
      return null;
    }
    const { description, badge, eNumberLabel, eNumberCode } = this.productInfo;
    return (h("div", { class: "main-product-info" }, description && h("h1", { class: "main-product-info__description" }, description), h("div", { class: "main-product-info__bottom" }, badge && (h("pes-badge-wrapper", { class: "main-product-info__bottom-item", type: badge.type, label: badge.label })), eNumberLabel && eNumberCode && (h("div", { class: "main-product-info__bottom-item main-product-info__bottom-item--e-number" }, h("div", null, eNumberLabel, ":\u00A0"), h("div", null, eNumberCode))), this.productCR && (h("h2", { class: "main-product-info__bottom-item main-product-info__bottom-item--product-id" }, this.productCR)))));
  }
  get el() { return getElement(this); }
};
MainProductInfo.style = mainProductInfoCss;

const MobileSliderContent = ({ selectedType, src }, children) => {
  return (h("div", { class: "mobile-content__viewer-content" },
    (selectedType === 'img'
      || selectedType === 'dimension'
      || selectedType === 'wiring-diagram')
      && children,
    selectedType === '3d' && h(Se3dWidget, { uri: src }),
    selectedType === '360' && h(Se360widget, { uri: src, scale: "250,250" }),
    selectedType === 'video'
      && h("div", { class: "mobile-content__viewer-video" },
        h("iframe", { class: "mobile-content__viewer-iframe", src: src }))));
};

const mediaGalleryPopupCss = ".dialog-header{z-index:10}.dialog-header__title{font-weight:normal;color:#333333;font-size:25px;line-height:1.44}:host(:not([dir=\"rtl\"])) .dialog-header__title{text-align:left}:host([dir=\"rtl\"]) .dialog-header__title{text-align:right}@media screen and (min-width: 980px){.dialog-header__title{font-size:30px;line-height:1.2}}.dialog-header__label{display:none}@media screen and (min-width: 980px){.dialog-header__label{display:flex;font-size:16px;font-weight:normal;margin:0;position:absolute;top:20px}:host(:not([dir=\"rtl\"])) .dialog-header__label{right:78px}:host([dir=\"rtl\"]) .dialog-header__label{left:78px}}@media screen and (min-width: 980px){.dialog-header__framed-text{border:1px solid #e7e6e6;border-radius:2px;font-weight:500;color:#333333;text-align:center;width:43px;height:28px}:host(:not([dir=\"rtl\"])) .dialog-header__framed-text{margin-right:10px}:host([dir=\"rtl\"]) .dialog-header__framed-text{margin-left:10px}}.dialog-content{overflow:hidden}.mobile-content{width:calc(100vw - 48px);margin:0 8px}@media screen and (max-width: 979px) and (orientation: landscape) and (min-width: 720px){.mobile-content{width:calc(100vw - 72px);margin:0 24px}}@media screen and (min-width: 980px){.mobile-content{display:none}}.mobile-content__wrapper{display:flex;flex-direction:column;align-items:center}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__wrapper{flex-direction:row;align-items:flex-start}}.mobile-content__viewer{order:1;display:flex;flex-direction:column;align-items:center;width:100%}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__viewer{order:2;flex-basis:100%}}.mobile-content__viewer-title{font-weight:bold;color:#333333;align-self:flex-start;font-size:16px;line-height:1.5625}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__viewer-title{display:none}}.mobile-content__viewer-content{padding:15px 0}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__viewer-content{padding:0}}.mobile-content__viewer-content .hydrated,.mobile-content__viewer-content .mobile-content__viewer-image,.mobile-content__viewer-content .mobile-content__viewer-video{display:block;width:calc(100vw - 48px);height:100vw}@media screen and (min-width: 720px){.mobile-content__viewer-content .hydrated,.mobile-content__viewer-content .mobile-content__viewer-image,.mobile-content__viewer-content .mobile-content__viewer-video{height:70vh}}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__viewer-content .hydrated,.mobile-content__viewer-content .mobile-content__viewer-image,.mobile-content__viewer-content .mobile-content__viewer-video{width:calc(100vw - 200px);height:calc(100vh - 140px)}}.mobile-content__viewer-image{background-position:center;background-size:contain;background-repeat:no-repeat}.mobile-content__viewer-content .mobile-content__viewer-image{max-width:369px}.mobile-content__viewer-video{min-width:288px;min-height:162px;border-width:0;background-color:#f3f2f2}.mobile-content__viewer-content .mobile-content__viewer-video{display:flex;align-items:center;justify-content:center;flex-wrap:wrap}@media screen and (min-width: 720px){.mobile-content__viewer-video{background:none}}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__viewer-video{min-width:347px;min-height:195px;background:none}}.mobile-content__viewer-iframe{width:inherit;height:calc((100vw - 48px) * 0.5625);min-width:inherit;min-height:inherit;display:block;border:none}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__viewer-iframe{width:calc((100vh - 140px) / 0.5625);height:calc((100vw - 200px) * 0.5625);max-width:calc(100vw - 200px);max-height:calc(100vh - 140px)}}.mobile-content__info{display:block;height:40px;margin-bottom:30px;width:calc(100vw - 48px)}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__info{display:none}}.mobile-content__info-image{color:#9fa0a4;text-align:center;font-size:12px;line-height:1.5}:host(:not([dir=\"rtl\"])) .mobile-content__info-icon{margin-right:8px}:host([dir=\"rtl\"]) .mobile-content__info-icon{margin-left:8px}.mobile-content__info-video{font-weight:bold;font-size:14px;line-height:1.4285714286}:host(:not([dir=\"rtl\"])) .mobile-content__info-video{text-align:left}:host([dir=\"rtl\"]) .mobile-content__info-video{text-align:right}.mobile-content__gallery{display:flex;order:2;overflow:auto;width:calc(100vw - 48px)}.mobile-content__gallery::-webkit-scrollbar{display:none}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__gallery{order:1;width:57px;height:calc(100vh - 140px);flex-direction:column}}.mobile-content__gallery-slide{display:flex;flex-shrink:0;position:relative;padding:0;width:48px;height:48px;border:1px solid #e7e6e6}:host(:not([dir=\"rtl\"])) .mobile-content__gallery-slide{margin-right:10px}:host([dir=\"rtl\"]) .mobile-content__gallery-slide{margin-left:10px}@media screen and (max-width: 979px) and (orientation: landscape){.mobile-content__gallery-slide{margin-bottom:10px}:host(:not([dir=\"rtl\"])) .mobile-content__gallery-slide{margin-right:0}:host([dir=\"rtl\"]) .mobile-content__gallery-slide{margin-left:0}}.mobile-content__gallery-slide--active{border:1px solid #3dcd58}.mobile-content__gallery-image{position:absolute;width:100%;height:auto;top:0;bottom:0;left:0;right:0;margin:auto}.mobile-content__gallery-image--small{width:29px;height:29px}.desktop-content{display:none}@media screen and (min-width: 980px){.desktop-content{display:flex;height:calc(100vh - 115px);margin:0 20px}}.desktop-content__gallery{display:flex;flex-direction:column;flex-shrink:0;width:310px;height:100%;overflow-y:auto;overflow-x:hidden}:host(:not([dir=\"rtl\"])) .desktop-content__gallery{margin-left:4px;padding-right:10px}:host([dir=\"rtl\"]) .desktop-content__gallery{margin-right:4px;padding-left:10px}.desktop-content__gallery-section{display:flex;margin-bottom:35px;flex-wrap:wrap;width:304px}.desktop-content__gallery-section:first-of-type{margin-bottom:20px}.desktop-content__gallery-section:last-of-type{margin-bottom:0}.desktop-content__gallery-title{width:100%;font-size:16px;font-weight:bold;color:#333333;margin-bottom:10px}.desktop-content__gallery-thumbnail{position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid #e7e6e6;width:58px;height:58px;padding:0;cursor:pointer;overflow:hidden}:host(:not([dir=\"rtl\"])) .desktop-content__gallery-thumbnail{margin:0 15px 15px 0}:host([dir=\"rtl\"]) .desktop-content__gallery-thumbnail{margin:0 0 15px 15px}.desktop-content__gallery-thumbnail--large{width:120px;height:88px}:host(:not([dir=\"rtl\"])) .desktop-content__gallery-thumbnail--large{margin:0 20px 0 0}:host([dir=\"rtl\"]) .desktop-content__gallery-thumbnail--large{margin:0 0 0 20px}.desktop-content__gallery-thumbnail--active{border-color:#3dcd58}.desktop-content__gallery-image{position:absolute;width:100%;height:auto;top:0;bottom:0;left:0;right:0;margin:auto}.desktop-content__gallery-image--small{width:29px;height:29px}.desktop-content__gallery-card{display:flex;margin-bottom:20px}.desktop-content__gallery-card:last-of-type{margin-bottom:0}.desktop-content__gallery-card-content{font-size:12px;width:150px}.desktop-content__gallery-card-title{overflow:hidden;display:block;-webkit-line-clamp:3;-webkit-box-orient:vertical;color:#333333;margin-bottom:10px;font-size:12px;line-height:1.5}.desktop-content__gallery-card-label{height:20px;padding:3px 5px;color:#626469;background-color:rgba(98, 100, 105, 0.1);text-transform:capitalize;border-radius:2px;font-size:12px;line-height:1.6666666667}.desktop-content__wrapper{width:100%;height:calc(100% - 40px);display:flex;justify-content:space-between;align-items:center}:host(:not([dir=\"rtl\"])) .desktop-content__wrapper{border-left:1px solid #e7e6e6}:host([dir=\"rtl\"]) .desktop-content__wrapper{border-right:1px solid #e7e6e6}.navigation-button{width:85px;cursor:pointer}.navigation-button-icon{color:rgba(51, 51, 51, 0.5)}:host([dir=\"rtl\"]) .navigation-button-icon{transform:scaleX(-1)}.navigation-button-icon--hidden{display:none}.slider{display:flex;justify-content:center;flex-direction:column;width:100%;align-items:center}.slider__content{max-width:inherit;width:100%;margin-bottom:20px}.slider__slide{width:inherit;min-width:100%}.slider__slide-image{width:inherit;height:100%;background-position:center;background-size:contain;background-repeat:no-repeat;cursor:zoom-in}.slider__slide-video{width:100%;height:100%;display:flex;align-items:center}.slider__slide-video-preview{position:relative;width:inherit;height:100%}.slider__slide-video-preview__link{position:absolute;top:0;width:100%;height:100%}:host(:not([dir=\"rtl\"])) .slider__slide-video-preview__link{left:0}:host([dir=\"rtl\"]) .slider__slide-video-preview__link{right:0}.slider__slide-video-preview__media{position:absolute;top:0;width:100%;height:100%;border:none}:host(:not([dir=\"rtl\"])) .slider__slide-video-preview__media{left:0}:host([dir=\"rtl\"]) .slider__slide-video-preview__media{right:0}.slider__slide-video-preview__button{position:absolute;top:50%;z-index:1;padding:0;width:68px;height:48px;border:none;background-color:transparent;cursor:pointer}:host(:not([dir=\"rtl\"])) .slider__slide-video-preview__button{left:50%;transform:translate(-50%, -50%)}:host([dir=\"rtl\"]) .slider__slide-video-preview__button{right:50%;transform:translate(50%, -50%)}.slider__slide-video-preview__button-shape{fill:#212121;fill-opacity:0.8}.slider__slide-video-preview__button-icon{fill:#fff}.slider__slide-video-preview__button:focus{outline:none}.slider__slide-video-preview:hover .slider__slide-video-preview__button-shape,.slider__slide-video-preview__button:focus .slider__slide-video-preview__button-shape{fill:#f00;fill-opacity:1}.slider__slide-video-preview--enabled{cursor:pointer}.slider__slide-video-iframe{width:inherit;border:none;display:block}.slider__info{width:100%;height:60px;color:#9fa0a4;font-size:16px}.slider__info-video-label{color:#333333;font-weight:normal;font-size:22px;line-height:1.2727272727}.slider__info-image-label{display:flex;align-items:center;justify-content:center;font-size:17px;line-height:1.4117647059}:host(:not([dir=\"rtl\"])) .slider__info-icon{margin-right:4px}:host([dir=\"rtl\"]) .slider__info-icon{margin-left:4px}.slider__navigation{display:flex;align-items:center;justify-content:center}.slider__navigation-arrow{width:30px;height:30px;border-radius:2px;color:#333333;background-repeat:no-repeat}:host(:not([dir=\"rtl\"])) .slider__navigation-arrow{margin-right:10px}:host([dir=\"rtl\"]) .slider__navigation-arrow{margin-left:10px;transform:scaleX(-1)}.slider__navigation-arrow--disabled{opacity:0.5}.slider__navigation-label{color:#9fa0a4;font-size:16px;line-height:1.5}:host(:not([dir=\"rtl\"])) .slider__navigation-label{margin-left:10px}:host([dir=\"rtl\"]) .slider__navigation-label{margin-right:10px}";

const DEFAULT_SLIDER_WIDTH = 930;
const DEFAULT_SLIDER_HEIGHT = 680;
const ASPECT_RATIO = 1.367;
const ASPECT_RATIO_VIDEO = 0.5625;
let MediaGalleryPopup = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.open = false;
    this.selectedMedia = 0;
    this.selected = this.selectedMedia;
    this.selectedType = 'img';
    this.sliderWrapperWidth = DEFAULT_SLIDER_WIDTH;
    this.galleryItems = [];
    this.mobile = isMobile();
    this.videoSlides = [];
    this.videoGroups = [];
    this.imagesToZoom = [];
    this.isRTL = document.documentElement.dir === 'rtl';
    this.directionModificator = 1 | -1;
    this.mainImgToZoomMobileRef = null;
    this.sliderWrapperRef = null;
    this.sliderWrapperHeight = DEFAULT_SLIDER_HEIGHT;
    this.sliderInfoHeight = 80;
    this.setSliderWrapperRef = (el) => {
      this.sliderWrapperRef = el;
    };
    this.setSliderWrapperDimensions = () => {
      var _a;
      if (((_a = this.sliderWrapperRef) === null || _a === void 0 ? void 0 : _a.offsetHeight) && !this.mobile) {
        const height = this.sliderWrapperRef.offsetHeight - this.sliderInfoHeight;
        this.sliderWrapperHeight = height > 0 && height < DEFAULT_SLIDER_HEIGHT ? height : DEFAULT_SLIDER_HEIGHT;
        this.sliderWrapperWidth = Math.ceil(this.sliderWrapperHeight * ASPECT_RATIO);
        this.videoSlides.forEach((item) => {
          const iframe = item.querySelector('iframe');
          if (iframe) {
            iframe.style.height = `${this.sliderWrapperWidth * ASPECT_RATIO_VIDEO}px`;
          }
        });
      }
    };
    this.render = () => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
      if (!this.items) {
        return null;
      }
      return (h("se-dialog", { size: "fill", color: "alternative", open: this.open }, h("se-dialog-header", { class: "dialog-header", color: "alternative", padding: "large", "close-icon": "true", option: "indent" }, h("h3", { class: "dialog-header__title" }, this.productLabel), h("p", { slot: "end", class: "label dialog-header__label" }, h("span", { class: "dialog-header__framed-text" }, "Esc"), (_b = (_a = this.items) === null || _a === void 0 ? void 0 : _a.gallery) === null || _b === void 0 ? void 0 :
        _b.labels.exitFullScreenModeLabel)), h("se-dialog-content", { class: "dialog-content" }, h("div", { class: "mobile-content" }, h("div", { class: "mobile-content__wrapper" }, h("div", { class: "mobile-content__viewer" }, h("div", { class: "mobile-content__viewer-title" }, (_d = (_c = this.galleryItems[this.selected]) === null || _c === void 0 ? void 0 : _c.groupLabel) !== null && _d !== void 0 ? _d : (_e = this.items) === null || _e === void 0 ? void 0 : _e.imgLabel, ":"), h(MobileSliderContent, { selectedType: this.selectedType, src: this.selectedType === 'video'
          ? this.galleryItems[this.selected].videoUrl
          : this.galleryItems[this.selected].src }, h("div", { class: "mobile-content__viewer-image", style: {
          backgroundImage: `url(${this.selectedType === 'img'
            ? this.galleryItems[this.selected].preview
            : this.galleryItems[this.selected].src})`,
        }, ref: (el) => (this.mainImgToZoomMobileRef = el) })), h("div", { class: "mobile-content__info" }, this.selectedType === 'video' ? (h("div", { class: "mobile-content__info-video" }, h("pes-smart-ellipsis", { maxHeight: "40px", content: this.galleryItems[this.selected].title, label: this.galleryItems[this.selected].language, modifier: "mobile-content__info-video" }))) : this.selectedType === '3d' || this.selectedType === '360' ? (h("div", { class: "mobile-content__info-image" }, h("pes-icon", { class: "mobile-content__info-icon" }, "move"), h("span", { class: "media-info-zoom-label" }, (_f = this.items) === null || _f === void 0 ? void 0 : _f.pdpDragToRotateLabel))) : (h("div", { class: "mobile-content__info-image" }, h("pes-icon", { class: "mobile-content__info-icon" }, "gesture_pointing"), h("span", { class: "media-info-zoom-label" }, (_g = this.items) === null || _g === void 0 ? void 0 : _g.dblTapImgLabel))))), h("div", { class: "mobile-content__gallery" }, [
        this.galleryItems.map((item, index) => (h("div", { class: classnames('mobile-content__gallery-slide', {
            'mobile-content__gallery-slide--active': this.selected === index,
          }), onClick: () => this.goToSlide(index) }, h("img", { src: item.type === 'video' ? item.thumbnailUrl : item.thumbnail || item.preview, alt: item.title, class: classnames('mobile-content__gallery-image', {
            'mobile-content__gallery-image--small': item.type === 'dimension' || item.type === 'wiring-diagram',
          }), loading: "lazy" })))),
      ]))), this.open && (h("div", { class: "desktop-content" }, h("aside", { class: "desktop-content__gallery" }, h("div", { class: "desktop-content__gallery-section" }, h("div", { class: "desktop-content__gallery-title" }, (_h = this.items) === null || _h === void 0 ? void 0 :
        _h.imgLabel, ":"), this.galleryItems.map((item, index) => item.type !== 'video' && (h("div", { class: classnames('desktop-content__gallery-thumbnail', {
          'desktop-content__gallery-thumbnail--active': this.selected === index,
        }), onClick: () => this.goToSlide(index) }, h("img", { src: item.thumbnail || item.preview, alt: item.title, class: classnames('desktop-content__gallery-image', {
          'desktop-content__gallery-image--small': item.type === 'dimension' || item.type === 'wiring-diagram',
        }), loading: "lazy" }))))), (_j = this.videoGroups) === null || _j === void 0 ? void 0 :
        _j.map((group) => (h("div", { class: "desktop-content__gallery-section" }, h("div", { class: "desktop-content__gallery-title" }, group.groupLabel, ":"), this.galleryItems.map((item, index) => item.type === 'video'
          && item.groupLabel === group.groupLabel && (h("div", { class: "desktop-content__gallery-card" }, h("div", { class: classnames('desktop-content__gallery-thumbnail desktop-content__gallery-thumbnail--large', {
            'desktop-content__gallery-thumbnail--active': this.selected === index,
          }), onClick: () => this.goToSlide(index) }, h("img", { src: item.thumbnailUrl, alt: item.title, class: "desktop-content__gallery-image", loading: "lazy" })), h("div", { class: "desktop-content__gallery-card-content" }, h("div", { class: "desktop-content__gallery-card-title" }, isWebkitLineClampSupports() ? (item.title) : (h("pes-ellipsis", { maxHeight: "55px", modifier: "desktop-content__gallery-card-title", content: item.title }))), h("span", { class: "desktop-content__gallery-card-label" }, item.language))))))))), h("div", { class: "desktop-content__wrapper", ref: this.setSliderWrapperRef }, h("div", { class: "navigation-button", onClick: () => (this.isRTL ? this.goToNextSlide() : this.goToPrevSlide()) }, h("pes-icon", { class: classnames('navigation-button-icon', {
          'navigation-button-icon--hidden': this.selected <= 0,
        }), size: pesIconSizes.XLARGE, customStyle: { fontSize: '85px' } }, "arrow2_left")), h("div", { class: "slider", style: { maxWidth: `${this.sliderWrapperWidth}px` } }, h("pdp-slider", { class: "slider__content", activeSlide: this.selected, "childs-class-name": ".slider__slide", "show-buttons": "false", sliderWidth: this.sliderWrapperWidth, panEnabled: false, direction: this.el.dir }, [
        this.galleryItems.map((item, index) => (h("div", { class: "slider__slide", style: { height: `${this.sliderWrapperHeight}px` } }, item.type === 'img' && this.renderSliderItem(item.preview, index), (item.type === 'dimension' || item.type === 'wiring-diagram')
          && this.renderSliderItem(item.src, index), item.type === '3d' && h(Se3dWidget, { uri: item.src }), item.type === '360' && h(Se360widget, { uri: item.src, scale: "600,600" }), item.type === 'video' && (h("div", { ref: (el) => (this.videoSlides[index] = el), class: "slider__slide-video", onClick: () => this.activateVideo(item, index) }, h("div", { class: "slider__slide-video-preview" }, h("a", { class: "slider__slide-video-preview__link", href: item.videoUrl }, h("img", { class: "slider__slide-video-preview__media", src: item.thumbnailUrl, alt: item.title, loading: "lazy" })), h("button", { class: "slider__slide-video-preview__button" }, h("svg", { width: "68", height: "48", viewBox: "0 0 68 48" }, h("path", { class: "slider__slide-video-preview__button-shape", d: "M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" }), h("path", { class: "slider__slide-video-preview__button-icon", d: "M 45,24 27,14 27,34" }))))))))),
      ]), h("div", { class: "slider__info" }, this.selectedType === 'video' ? (h("div", { class: "slider__info-video-label" }, h("pes-smart-ellipsis", { maxHeight: "60px", content: (_k = this.galleryItems[this.selected]) === null || _k === void 0 ? void 0 : _k.title, label: (_l = this.galleryItems[this.selected]) === null || _l === void 0 ? void 0 : _l.language, modifier: "slider__info-video" }))) : ([
        h("div", { class: "slider__info-image-label" }, this.selectedType === '3d' || this.selectedType === '360'
          ? [
            h("pes-icon", { class: "slider__info-icon", customStyle: { fontSize: '20px' } }, "move"),
            h("span", null, (_m = this.items) === null || _m === void 0 ? void 0 : _m.pdpDragToRotateLabel),
          ]
          : [
            h("pes-icon", { class: "slider__info-icon", size: pesIconSizes.MEDIUM }, "action_zoom_plus_stroke"),
            h("span", null, (_p = (_o = this.items) === null || _o === void 0 ? void 0 : _o.gallery) === null || _p === void 0 ? void 0 : _p.labels.clickZoomInLabel),
          ]),
      ]))), h("div", { class: "navigation-button", onClick: () => (this.isRTL ? this.goToPrevSlide() : this.goToNextSlide()) }, h("pes-icon", { class: classnames('navigation-button-icon', {
          'navigation-button-icon--hidden': this.slideCount - 1 <= this.selected,
        }), mirror: pesIconMirrorDirection.HORIZONTAL, size: pesIconSizes.XLARGE, customStyle: { fontSize: '85px' } }, "arrow2_left"))))), this.showZoomViewer
        && (this.mobile ? !isEmpty_1(this.mainImgToZoomMobile) : !!((_q = this.imagesToZoom) === null || _q === void 0 ? void 0 : _q.length)) && (h("pes-popup-zoom-viewer", { selectedImageSrc: this.selectedImageSrc, selectedImageTitle: this.selectedImageTitle, mainImgToZoomMobile: this.mainImgToZoomMobile, imagesToZoom: this.imagesToZoom, desktopZoomedImgSize: 1500, mobileZoomedImgSize: 560, srcImgHeight: this.mobile ? 280 : 680, srcImgWidth: this.mobile ? 280 : 680, zoomOutLabel: (_s = (_r = this.items) === null || _r === void 0 ? void 0 : _r.gallery) === null || _s === void 0 ? void 0 : _s.labels.clickZoomOutLabel, offsetZoomedImgX: 150, popupOpen: this.open })))));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  optionDidChange(selectedMedia) {
    this.selected = selectedMedia;
  }
  didPopupClose() {
    if (this.selectedType === 'video') {
      this.preventPlayingVideo(this.selected);
    }
  }
  goToNextSlide() {
    this.goToSlide(this.selected + this.directionModificator);
  }
  goToPrevSlide() {
    this.goToSlide(this.selected - this.directionModificator);
  }
  goToSlide(index) {
    if (index >= 0 && index < this.slideCount) {
      if (this.selectedType === 'video') {
        this.preventPlayingVideo(this.selected);
      }
      this.selected = index;
    }
  }
  preventPlayingVideo(index) {
    const iframe = this.videoSlides[index].querySelector('iframe');
    if (iframe) {
      iframe.setAttribute('src', iframe.getAttribute('src').split('?')[0]);
    }
  }
  arrowNavigation(ev) {
    switch (ev.key) {
      case 'ArrowLeft':
        this.goToPrevSlide();
        break;
      case 'ArrowRight':
        this.goToNextSlide();
        break;
    }
  }
  activateVideo(item, index) {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('src', `${item.videoUrl}?rel=0&showinfo=0&autoplay=1`);
    iframe.classList.add('slider__slide-video-iframe');
    iframe.style.height = `${this.sliderWrapperWidth * ASPECT_RATIO_VIDEO}px`;
    this.videoSlides[index].innerHTML = '';
    this.videoSlides[index].appendChild(iframe);
  }
  renderSliderItem(src, index) {
    return (h("div", { class: "slider__slide-image", style: {
        backgroundImage: `url(${src})`,
      }, ref: (el) => {
        if (el) {
          this.imagesToZoom[index] = el;
        }
      } }));
  }
  connectedCallback() {
    this.arrowNavigation = this.arrowNavigation.bind(this);
    document.addEventListener('keydown', this.arrowNavigation);
    window.addEventListener('resize', this.setSliderWrapperDimensions);
  }
  componentWillLoad() {
    var _a, _b, _c;
    this.galleryItems = createSlides(this.items);
    this.slideCount = (_a = this.galleryItems.length) !== null && _a !== void 0 ? _a : 0;
    this.videoGroups = (_c = (_b = this.items) === null || _b === void 0 ? void 0 : _b.gallery) === null || _c === void 0 ? void 0 : _c.videoGroups;
    this.directionModificator = this.isRTL ? -1 : 1;
  }
  setSelectedImgSrc() {
    var _a, _b, _c;
    this.selectedType = (_a = this.galleryItems[this.selected]) === null || _a === void 0 ? void 0 : _a.type;
    this.mainImgToZoomMobile = this.mainImgToZoomMobileRef;
    this.selectedImageSrc = this.mobile && this.selectedType === 'img'
      ? (_b = this.galleryItems[this.selected]) === null || _b === void 0 ? void 0 : _b.mobile
      : (_c = this.galleryItems[this.selected]) === null || _c === void 0 ? void 0 : _c.src;
  }
  componentWillRender() {
    var _a, _b;
    this.selectedType = (_a = this.galleryItems[this.selected]) === null || _a === void 0 ? void 0 : _a.type;
    this.showZoomViewer = this.selectedType === 'img'
      || this.selectedType === 'dimension'
      || this.selectedType === 'wiring-diagram';
    this.setSelectedImgSrc();
    this.selectedImageTitle = (_b = this.galleryItems[this.selected]) === null || _b === void 0 ? void 0 : _b.title;
  }
  componentDidRender() {
    this.setSliderWrapperDimensions();
    this.setSelectedImgSrc();
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.arrowNavigation);
    window.removeEventListener('resize', this.setSliderWrapperDimensions);
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "selectedMedia": ["optionDidChange"]
  }; }
};
MediaGalleryPopup.style = mediaGalleryPopupCss;

const mediaGalleryZoomCss = ".zoom__area{overflow:hidden;position:relative;-webkit-user-select:none;user-select:none}.zoom__img{width:inherit;height:inherit;cursor:pointer}.zoom__lens{position:absolute;cursor:pointer;height:80px;width:118px;outline:1px solid #42b4e6;border:1px solid #ffffff;box-shadow:0 0 0 0 rgba(51, 51, 51, 0.4) inset, 0 0 0 369px rgba(51, 51, 51, 0.4)}.zoom__lens--hidden{display:none}.zoom__viewer{position:absolute;z-index:3;box-shadow:0 2px 5px 0 rgba(51, 51, 51, 0.25);background-color:#ffffff;background-repeat:no-repeat;background-position:center;height:369px;display:block;top:0}:host(:not([dir=\"rtl\"])) .zoom__viewer{left:100%;margin-left:25px}:host([dir=\"rtl\"]) .zoom__viewer{right:100%;margin-right:25px}.zoom__viewer--hidden{display:none}.zoom__viewer-hint{position:absolute;display:flex;align-items:center;bottom:0;margin:0;width:100%;height:50px;font-size:14px;font-weight:normal;color:#b10043;background-color:#ffffff;opacity:0.9}:host(:not([dir=\"rtl\"])) .zoom__viewer-hint-icon{margin-left:17px;margin-right:3px}:host([dir=\"rtl\"]) .zoom__viewer-hint-icon{margin-right:17px;margin-left:3px}";

let MediaGalleryZoom = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didZoomOpen = createEvent(this, "didZoomOpen", 7);
    this.parentWidth = MAX_PDP_WIDTH;
    this.zoomAreaWidth = ZOOM_AREA_WIDTH;
    this.zoomOpen = false;
    this.zoomViewerMarginLeft = 25;
    this.zoomViewerWidth = 0;
    this.zoomRatio = 6;
    this.onMouseMove = (event) => {
      const dimensions = this.smallImage.getBoundingClientRect();
      const cursorX = event.clientX - dimensions.left;
      const cursorY = event.clientY - dimensions.top;
      if (this.zoomLens) {
        let x = cursorX - this.zoomLens.offsetWidth / 2;
        let y = cursorY - this.zoomLens.offsetHeight / 2;
        const rightBound = this.smallImage.offsetWidth - this.zoomLens.offsetWidth;
        const bottomBound = this.smallImage.offsetWidth - this.zoomLens.offsetHeight;
        if (x > rightBound) {
          x = rightBound;
        }
        if (x < 0) {
          x = 0;
        }
        if (y > bottomBound) {
          y = bottomBound;
        }
        if (y < 0) {
          y = 0;
        }
        this.zoomLens.style.left = `${x}px`;
        this.zoomLens.style.top = `${y}px`;
        this.zoomedImage.style.backgroundPosition = `-${x * this.zoomRatio}px -${y * this.zoomRatio}px`;
      }
    };
    this.onMouseEnter = (src) => {
      this.zoomOpen = true;
      this.zoomedImage.style.backgroundImage = `url(${src})`;
      this.zoomedImage.style.backgroundSize = `${this.smallImage.width * this.zoomRatio}px ${this.smallImage.height * this.zoomRatio}px`;
      this.didZoomOpen.emit(true);
    };
    this.onMouseLeave = () => {
      this.zoomOpen = false;
      this.didZoomOpen.emit(false);
    };
    this.setZoomViewerWidth = (parentWidth) => {
      this.zoomViewerWidth = parentWidth - this.zoomAreaWidth - this.zoomViewerMarginLeft;
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  parentWidthChanged(newWidth) {
    this.setZoomViewerWidth(newWidth);
  }
  componentWillLoad() {
    this.setZoomViewerWidth(this.parentWidth);
  }
  render() {
    return [
      h("div", { class: "zoom__area", style: { width: `${this.zoomAreaWidth}px`, height: `${this.zoomAreaWidth}px` } }, this.showBrandLogos && (h("pes-brand-logos", { greenPremiumLogo: this.greenPremiumLogo, pdsLogo: this.pdsLogo, energyStarLogo: this.energyStarLogo, onMouseMove: this.onMouseMove, onMouseEnter: () => this.onMouseEnter(this.imageSource), onMouseLeave: this.onMouseLeave })), h("div", { class: classnames('zoom__lens', { 'zoom__lens--hidden': !this.zoomOpen }), style: {
          width: `${Math.round(this.zoomViewerWidth / this.zoomRatio)}px`,
          height: `${Math.round(this.zoomAreaWidth / this.zoomRatio)}px`,
        }, ref: (el) => (this.zoomLens = el), onMouseMove: this.onMouseMove, onMouseEnter: () => this.onMouseEnter(this.imageSource), onMouseLeave: this.onMouseLeave, onClick: this.handleClick }), h("img", { class: "zoom__img", src: this.imagePreviewSource, onMouseMove: this.onMouseMove, onMouseEnter: () => this.onMouseEnter(this.imageSource), onMouseLeave: this.onMouseLeave, onClick: this.handleClick, ref: (el) => (this.smallImage = el), alt: this.imageTitle, fetchpriority: "high" })),
      h("div", { class: classnames('zoom__viewer', { 'zoom__viewer--hidden': !this.zoomOpen }), style: { width: `${this.zoomViewerWidth}px` }, ref: (el) => (this.zoomedImage = el) }, this.showHighResImageNotAvailableHint && (h("div", { class: "zoom__viewer-hint" }, h("pes-icon", { customStyle: { fontSize: '26px' }, class: "zoom__viewer-hint-icon" }, "notification_critical_stroke"), "\u00A0", this.imageLoadingErrorLabel))),
    ];
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "parentWidth": ["parentWidthChanged"]
  }; }
};
MediaGalleryZoom.style = mediaGalleryZoomCss;

const pesOfflineStoresCss = ".offline-stores{display:flex;flex-direction:column}@media screen and (max-width: 979px){.offline-stores{align-items:center;padding:4px 0}}.offline-stores--delivery{margin-bottom:8px;font-size:0.875rem;line-height:20px;color:#626469;text-transform:none;display:flex}:host(:not([dir=\"rtl\"])) .offline-stores--delivery{padding-left:2px}:host([dir=\"rtl\"]) .offline-stores--delivery{padding-right:2px}.offline-stores--delivery-without-margin{margin:0}.offline-stores--delivery-time{margin:0;padding-right:4px;padding-left:4px;font-weight:bold}.offline-stores--tooltip{position:relative;top:2px}.offline-stores__link-wrapper{display:flex;align-items:center}.offline-stores__link{position:relative;color:#42b4e6;text-decoration:none;outline:none}.offline-stores__link:hover{text-decoration:underline}.offline-stores__link-label{font-size:0.875rem}.offline-stores__link-icon{position:relative;top:4px}:host(:not([dir=\"rtl\"])) .offline-stores__link-icon{margin-right:4px}:host([dir=\"rtl\"]) .offline-stores__link-icon{margin-left:4px}.offline-stores--mobile-arrow{display:none}@media screen and (max-width: 979px){.offline-stores--mobile-arrow{display:block;position:relative;color:#42b4e6;top:4px}:host(:not([dir=\"rtl\"])) .offline-stores--mobile-arrow{margin-left:4px}:host([dir=\"rtl\"]) .offline-stores--mobile-arrow{margin-right:4px;transform:scaleX(-1)}}";

let PesOfflineStores = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.enableProductSelectorButton = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "offline-stores" }, this.contentText && (h("div", { class: classnames('offline-stores--delivery', {
        'offline-stores--delivery-without-margin': !this.resellerUrl,
      }) }, h("span", null, `${this.contentText} `), h("p", { class: "offline-stores--delivery-time", innerHTML: this.deliveryTime }), this.tooltipText && (h("pdp-icon-tooltip", { iconColor: "grey", iconSize: "micro", icon: "information_stroke", innerHTML: this.tooltipText, class: "offline-stores--tooltip" })))), this.resellerUrl && !this.enableProductSelectorButton && (h("div", { class: "offline-stores__link-wrapper" }, h("a", { href: this.resellerUrl, class: "offline-stores__link" }, h("pes-icon", { class: "offline-stores__link-icon" }, "location_map"), h("span", { class: "offline-stores__link-label" }, this.labelLink)), isMobile() && (h("pes-icon", { class: "offline-stores--mobile-arrow", mirror: pesIconMirrorDirection.HORIZONTAL, size: pesIconSizes.NANO }, "arrow2_left"))))));
  }
  get el() { return getElement(this); }
};
PesOfflineStores.style = pesOfflineStoresCss;

const productVariantsCss = ":host .product-variants .product-variants__row{margin-bottom:5px}:host .product-variants .product-variants__row.dropdown{margin-bottom:15px}:host .product-variants .product-variants__row p{font-weight:bold;margin-top:0;margin-bottom:10px}:host(:not([dir=\"rtl\"])) .product-variants .product-variants__row p{text-align:left}:host([dir=\"rtl\"]) .product-variants .product-variants__row p{text-align:right}:host .product-variants .product-variants__row .links{display:flex;align-content:flex-start;flex-direction:row;flex-wrap:wrap}:host(:not([dir=\"rtl\"])) .product-variants .product-variants__row .links{margin-left:-5px}:host([dir=\"rtl\"]) .product-variants .product-variants__row .links{margin-right:-5px}:host .product-variants .product-variants__row .links .plug{min-height:40px}:host .product-variants .product-variants__row .links .selected{margin-bottom:6px}:host(:not([dir=\"rtl\"])) .product-variants .product-variants__row .links .selected{margin-right:6px}:host([dir=\"rtl\"]) .product-variants .product-variants__row .links .selected{margin-left:6px}:host .product-variants .product-variants__row .links .text{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}:host .product-variants .product-variants__row .links pes-router-link{margin-bottom:6px;overflow:hidden}:host(:not([dir=\"rtl\"])) .product-variants .product-variants__row .links pes-router-link{margin-right:6px}:host([dir=\"rtl\"]) .product-variants .product-variants__row .links pes-router-link{margin-left:6px}:host .product-variants .product-variants__row .links pes-router-link a{text-decoration:none}:host .product-variants .product-variants__row .links se-chip{min-height:40px}";

const OLD_ACTIVE_ITEM = 'green';
const ACTIVE_ITEM = 'selected';
let PesPdpProductVariants = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onProductVariantsSelect = (valueId) => {
      if (this.isVariantsNew) {
        let char;
        let charId;
        let itemCount;
        for (const el of this.variantsData.chars) {
          char = el.variants.find((variant) => variant.valueId === valueId);
          if (char !== undefined) {
            charId = el.charId;
            itemCount = el.variants.findIndex((variant) => variant.valueId === valueId);
            break;
          }
        }
        send(productVariantsClickEvent, {
          brand: char.brand,
          category: this.variantsData.groupId,
          id: char.productId,
          name: char.valueId,
          position: itemCount + 1,
          price: char.price ? char.price : null,
          variant: charId,
          currency: char.currency,
        });
      }
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  selectedValue(event) {
    const { selectedValue } = event.detail;
    const { url, productId } = this.findVariantById(selectedValue);
    this.onProductVariantsSelect(selectedValue);
    if (isAppRoutingEnabled()) {
      const route = new PesRoute({ page: pesCatalogPageTypes.PRODUCT, pageId: productId });
      navigateWithRouter(route, this.el);
    }
    else {
      document.location.href = url;
    }
  }
  validateSelectData(data) {
    const selectData = [];
    data.map((variant) => {
      return selectData.push({
        value: variant.valueId,
        label: variant.value,
        selected: this.isActiveVariantType(variant.type),
      });
    });
    return selectData;
  }
  isActiveVariantType(variantType) {
    return variantType === OLD_ACTIVE_ITEM || variantType === ACTIVE_ITEM;
  }
  findVariantById(valueId) {
    for (const el of this.variantsData.chars) {
      const v = el.variants.find((variant) => variant.valueId === valueId);
      if (v)
        return v;
    }
  }
  showLinks(data) {
    return (h("div", { class: "links" }, data.map((variant) => {
      if (this.isActiveVariantType(variant.type)) {
        return (h("se-chip", { class: "selected", selected: "true" }, h("span", { slot: "start", class: "text", title: variant.value, innerHTML: variant.value })));
      }
      const dashed = variant.type === 'dash' ? { dashed: '' } : null;
      return (h(PesProductLink, { className: variant.type, url: variant.url, id: variant.productId, enableAppRouting: isAppRoutingEnabled() }, h("a", { href: variant.url, title: html2plain(variant.value), onClick: () => this.onProductVariantsSelect(variant.valueId) }, h("se-chip", Object.assign({}, dashed), h("span", { slot: "start", class: "text", title: variant.value, innerHTML: variant.value })))));
    })));
  }
  componentWillLoad() {
    this.isVariantsNew = this.variants.hasOwnProperty('chars');
    this.variantsData = this.isVariantsNew ? this.variants : { chars: this.variants };
  }
  render() {
    var _a, _b, _c;
    if (!((_a = this.variantsData) === null || _a === void 0 ? void 0 : _a.chars)) {
      return null;
    }
    return (h(Host, { class: "subsection__item" }, h("div", { class: "product-variants" }, (_c = (_b = this.variantsData) === null || _b === void 0 ? void 0 : _b.chars) === null || _c === void 0 ? void 0 : _c.map((item) => {
      return (h("div", { class: classnames('product-variants__row', { dropdown: item.dropdown }) }, h("p", null, item.title, ":"), item.dropdown ? (h("pes-select", { items: this.validateSelectData(item.variants) })) : (this.showLinks(item.variants))));
    }))));
  }
  get el() { return getElement(this); }
};
PesPdpProductVariants.style = productVariantsCss;

const tabsCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.tabbar{overflow:hidden}";

let PDPTabs = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.tabClicked = createEvent(this, "tabClicked", 7);
    this.tabs = [];
    this.handleClick = (tab) => {
      this.tabClicked.emit({
        type: tab.type,
        title: tab.title,
      });
      setTabActive(tab);
      this.setActive(tab);
    };
    this.defineTabType = () => {
      switch (window.location.hash) {
        case '#pdp-documents':
          return ETabType.DDC_DOCUMENTS;
        case '#pdp-reviews':
          return ETabType.REVIEWS;
        default:
          return null;
      }
    };
    this.initialScrolling = () => {
      var _a;
      const tabType = this.defineTabType();
      if (tabType) {
        const tabTitle = ((_a = this.tabs.filter((t) => t.type === tabType)[0]) === null || _a === void 0 ? void 0 : _a.title) || '';
        const tab = {
          type: tabType,
          title: tabTitle,
        };
        this.handleClick(tab);
      }
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentDidUpdate() {
    this.updateScrollPosition();
  }
  updateScrollPosition() {
    var _a, _b;
    const activeLink = (_a = this.navRef) === null || _a === void 0 ? void 0 : _a.querySelector('.active');
    const scrollContainer = (_b = this.navRef) === null || _b === void 0 ? void 0 : _b.parentElement;
    if (this.activeTab && activeLink && activeLink !== this.activeLinkRef) {
      this.activeLinkRef = activeLink;
      const threshold = 40;
      const linkStartPosition = activeLink.offsetLeft;
      const linkEndPosition = linkStartPosition + activeLink.offsetWidth + threshold;
      const viewportStartPosition = scrollContainer.scrollLeft;
      const viewportEndPosition = viewportStartPosition + scrollContainer.offsetWidth;
      if (linkEndPosition > viewportEndPosition) {
        scrollContainer.scrollLeft = Math.min(linkEndPosition - scrollContainer.offsetWidth, scrollContainer.scrollWidth - scrollContainer.offsetWidth);
      }
      else if (linkStartPosition < viewportStartPosition) {
        scrollContainer.scrollLeft = Math.max(0, linkStartPosition - threshold);
      }
    }
  }
  handleActiveTab() {
    this.setActive(this.getActiveTab());
  }
  setActive(tab) {
    this.activeTab = tab;
  }
  getActiveTab() {
    return window.__STICKYBARSTORE.active;
  }
  getTabs() {
    const storedTabs = window.__STICKYBARSTORE
      .items;
    const deduplicatedTabs = [...new Set(storedTabs)];
    const tabs_ordered = TABS_ORDER.reduce((acc, TAB) => {
      const foundTab = deduplicatedTabs.find(({ name }) => name === TAB);
      if (foundTab) {
        const newTabs = foundTab.titles.map((title) => ({
          type: foundTab.name,
          title,
        }));
        return [...acc, ...newTabs];
      }
      return acc;
    }, []);
    return this.el.dir === 'rtl' ? tabs_ordered.reverse() : tabs_ordered;
  }
  handleTabInit() {
    this.tabs = this.getTabs();
    this.initialScrolling();
  }
  componentDidLoad() {
    this.tabs = this.getTabs();
    this.setActive(this.getActiveTab());
    this.initialScrolling();
  }
  componentDidRender() {
    this.navRef.dispatchEvent(new CustomEvent('scroll', { bubbles: true }));
  }
  render() {
    return (h("se-tabbar", { color: "alternative", class: "tabbar" }, h("nav", { ref: (el) => (this.navRef = el) }, this.tabs.map((tab) => {
      var _a;
      return (h("a", { onClick: () => this.handleClick(tab), title: tab.title, class: ((_a = this.activeTab) === null || _a === void 0 ? void 0 : _a.title) === tab.title ? 'active' : '' }, tab.title));
    }))));
  }
  get el() { return getElement(this); }
};
PDPTabs.style = tabsCss;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol_1(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol_1(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = _compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = _arrayMap(iteratees, function(iteratee) {
      if (isArray_1(iteratee)) {
        return function(value) {
          return _baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity_1];
  }

  var index = -1;
  iteratees = _arrayMap(iteratees, _baseUnary(_baseIteratee));

  var result = _baseMap(collection, function(value, key, collection) {
    var criteria = _arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return _baseSortBy(result, function(object, other) {
    return _compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return _setToString(_overRest(func, start, identity_1), func + '');
}

var _baseRest = baseRest;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject_1(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike_1(object) && _isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq_1(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = _baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && _isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && _isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return _baseOrderBy(collection, _baseFlatten(iteratees, 1), []);
});

var sortBy_1 = sortBy;

const substitutionType = {
  RANGE: 'RANGE',
  GROUP: 'GROUP',
  PRODUCT: 'PRODUCT',
};
const MAX_SUBSTITUTIONS_VISIBLE_BY_DEFAULT = 3;
const substitutionsOrder = {
  [substitutionType.RANGE]: 1,
  [substitutionType.GROUP]: 2,
  [substitutionType.PRODUCT]: 3,
};
const PRODUCTS_NUMBER_LABEL_PLACEHOLDER = '#number of products#';

const getProductsQuantityMap = (products) => {
  return products.reduce((result, product) => {
    result[product.product.skuId] = product.quantity;
    return result;
  }, {});
};
const getLabelsBySubstitutionType = (type, cartTransferEnabled, labels) => {
  if (type === substitutionType.PRODUCT) {
    return {
      addToCartLabel: labels.addToCartProductLabel,
      removeFromCartLabel: cartTransferEnabled
        ? labels.addToCartProductLabel
        : labels.removeFromCartProductLabel,
    };
  }
  if (type === substitutionType.GROUP) {
    return {
      addToCartLabel: labels.addToCartGroupLabel,
      removeFromCartLabel: cartTransferEnabled
        ? labels.addToCartGroupLabel
        : labels.removeFromCartGroupLabel,
    };
  }
};
const getIsSubstitutionInMyProducts = (substitution, myProducts) => {
  if ((myProducts === null || myProducts === void 0 ? void 0 : myProducts.length) === 0) {
    return false;
  }
  if (substitution.type === substitutionType.PRODUCT) {
    const { quantity, product: { skuId }, } = substitution.products[0];
    const product = { [skuId]: quantity };
    return isProductInMyProducts(product, myProducts);
  }
  if (substitution.type === substitutionType.GROUP) {
    const products = getProductsQuantityMap(substitution.products);
    return isProductGroupInMyProducts(products, myProducts);
  }
  return false;
};

const substitutionsCss = ":host{display:block}.substitutions__header{color:#333333;font-size:0.875rem;line-height:1rem;margin:0 0 10px}";

let Substitutions = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isExpanded = false;
    this.myProducts = [];
    this.getIsCTAsHidden = () => {
      if (isAppRoutingEnabled()) {
        return !(getIsCustomAddToCartEnabled() || getIsCustomAddToFavoritesEnabled());
      }
      return this.hideCtas;
    };
    this.getIsSubstitutionInCart = (substitution) => {
      if (isAppRoutingEnabled()) {
        if (getIsCustomAddToCartEnabled()) {
          if (substitution.type === substitutionType.GROUP) {
            const ids = substitution.products.map((product) => product.product.skuId);
            return getIsProductsInCustomCart(ids);
          }
          if (substitution.type === substitutionType.PRODUCT) {
            return getIsProductsInCustomCart([substitution.products[0].product.skuId]);
          }
          return false;
        }
        if (getIsCustomAddToFavoritesEnabled()) {
          if (substitution.type === substitutionType.GROUP) {
            const ids = substitution.products.map((product) => product.product.skuId);
            return getIsProductsInCustomFavorites(ids);
          }
          if (substitution.type === substitutionType.PRODUCT) {
            return getIsProductsInCustomFavorites([substitution.products[0].product.skuId]);
          }
          return false;
        }
        return false;
      }
      return getIsSubstitutionInMyProducts(substitution, this.myProducts);
    };
    this.getIsCartTransferEnabled = () => {
      if (isAppRoutingEnabled()) {
        return getIsCustomAddToCartEnabled();
      }
      return this.cartTransferEnabled;
    };
    this.getCTALabels = (substitution) => {
      if (isAppRoutingEnabled()) {
        if (getIsCustomAddToCartEnabled()) {
          return {
            addToCartLabel: getCustomAddToCartSettings().labels.addLabel,
            removeFromCartLabel: getCustomAddToCartSettings().labels.removeLabel,
          };
        }
        if (getIsCustomAddToFavoritesEnabled()) {
          return {
            addToCartLabel: getCustomAddToFavoritesSettings().labels.addLabel,
            removeFromCartLabel: getCustomAddToFavoritesSettings().labels.removeLabel,
          };
        }
        return {
          addToCartLabel: this.addToCartProductLabel,
          removeFromCartLabel: this.removeFromCartProductLabel,
        };
      }
      return getLabelsBySubstitutionType(substitution.type, this.cartTransferEnabled, {
        addToCartProductLabel: this.addToCartProductLabel,
        removeFromCartProductLabel: this.removeFromCartProductLabel,
        addToCartGroupLabel: this.addToCartGroupLabel,
        removeFromCartGroupLabel: this.removeFromCartGroupLabel,
      });
    };
    this.renderSubstitutionByType = (substitution, options) => {
      const commonProps = {
        header: substitution.title,
        headless: options.headless,
        comment: substitution.comment,
        productId: this.productId,
      };
      const props = ((substitution) => {
        if (substitution.type === substitutionType.RANGE) {
          return Object.assign(Object.assign({}, commonProps), { hasCTA: false, footerless: true });
        }
        const productsQuantityMap = getProductsQuantityMap(substitution.products);
        const labels = this.getCTALabels(substitution);
        const otherProps = Object.assign(Object.assign(Object.assign({}, commonProps), labels), { hasCTA: !this.getIsCTAsHidden(), inCart: this.getIsSubstitutionInCart(substitution), isCartTransferEnabled: this.getIsCartTransferEnabled(), products: productsQuantityMap });
        if (substitution.type === substitutionType.GROUP) {
          return Object.assign(Object.assign({}, otherProps), { groupId: substitution.substitutionId });
        }
        return Object.assign({}, otherProps);
      })(substitution);
      const children = ((substitution) => {
        if (substitution.type === substitutionType.RANGE) {
          return (h("pes-substitutions-option-item", { type: "range", header: substitution.range.name, quantityLabel: this.productsNumberLabel.replace(PRODUCTS_NUMBER_LABEL_PLACEHOLDER, substitution.range.productsCount.toString()), imageURL: substitution.range.image.url, imageTitle: substitution.range.image.title, description: substitution.range.description, url: substitution.range.url, key: substitution.range.id, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalSubstitutionKey: substitution.range.id }));
        }
        return substitution === null || substitution === void 0 ? void 0 : substitution.products.map((item) => (h("pes-substitutions-option-item", { header: item.product.skuId, quantityLabel: `${item.quantity}×`, imageURL: item.product.imageLink.url, imageTitle: item.product.imageLink.title, description: item.product.description, url: item.productUrl, key: item.product.skuId, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig, externalSubstitutionKey: item.product.skuId })));
      })(substitution);
      return h("pes-substitutions-option", Object.assign({}, props, { content: children }));
    };
    this.renderSubstitution = (substitution, index, substitutions) => {
      const isStackedProduct = index > 0
        && substitutions[index - 1].type === substitutionType.PRODUCT
        && substitutions[index].type === substitutionType.PRODUCT;
      return (h(Fragment, null, index > 0 && !isStackedProduct && h("pes-substitutions-delimiter", { label: this.orLabel }), this.renderSubstitutionByType(substitution, { headless: isStackedProduct })));
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleShowMoreLessClicked(e) {
    e.stopPropagation();
    this.isExpanded = !this.isExpanded;
  }
  componentDidLoad() {
    getMyProductsFromConnector().then((res) => (this.myProducts = res));
  }
  render() {
    const sortedSubstitutions = sortBy_1(this.substitutions, (substitution) => substitutionsOrder[substitution.type]);
    const substitutionsToShow = sortedSubstitutions === null || sortedSubstitutions === void 0 ? void 0 : sortedSubstitutions.slice(0, this.isExpanded ? Infinity : MAX_SUBSTITUTIONS_VISIBLE_BY_DEFAULT);
    const hasShowMoreLessButton = this.substitutions.length > MAX_SUBSTITUTIONS_VISIBLE_BY_DEFAULT;
    return (h("section", { class: "substitutions" }, h("h2", { class: "substitutions__header" }, this.header), substitutionsToShow.map(this.renderSubstitution), hasShowMoreLessButton && (h("pes-substitutions-show-more-less-button", { showMoreLabel: this.showMoreLabel, showLessLabel: this.showLessLabel, isExpanded: this.isExpanded }))));
  }
  get el() { return getElement(this); }
};
Substitutions.style = substitutionsCss;

const delimiterCss = ":host{display:block}.delimiter{padding:16px 0;text-align:center;text-transform:uppercase;font-size:0.75rem;line-height:1rem;color:#626469}";

let SubstitutionsDelimiter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("div", { class: "delimiter" }, this.label);
  }
};
SubstitutionsDelimiter.style = delimiterCss;

const notFoundCss = ":host{display:block}slot{font-size:0.875rem;line-height:1.25rem;color:#333333}::slotted(a){color:#42b4e6;text-decoration:none}::slotted(a:hover),::slotted(a:focus){text-decoration:underline}";

let SubstitutionsNotFound = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.content = '';
  }
  render() {
    return h("pes-substitutions-option", { container: true, content: this.content });
  }
};
SubstitutionsNotFound.style = notFoundCss;

const optionItemCss = ":host{display:block}.substitution-option-item{display:flex;text-decoration:none}@media screen and (max-width: 979px){.substitution-option-item{position:relative}}.substitution-option-item__count{color:#626469;font-size:1rem}@media screen and (max-width: 979px){.substitution-option-item:not(.substitution-option-item--type-range) .substitution-option-item__count{position:absolute;top:-14px}:host(:not([dir=\"rtl\"])) .substitution-option-item:not(.substitution-option-item--type-range) .substitution-option-item__count{right:0}:host([dir=\"rtl\"]) .substitution-option-item:not(.substitution-option-item--type-range) .substitution-option-item__count{left:0}}@media screen and (min-width: 980px){.substitution-option-item__count{box-sizing:border-box;min-width:40px;line-height:50px}:host(:not([dir=\"rtl\"])) .substitution-option-item__count{padding-left:5px}:host([dir=\"rtl\"]) .substitution-option-item__count{padding-right:5px}}.substitution-option-item--type-range .substitution-option-item__count{font-size:0.625rem;line-height:1.25rem;color:#626469}:host(:not([dir=\"rtl\"])) .substitution-option-item--type-range .substitution-option-item__count{padding-left:0}:host([dir=\"rtl\"]) .substitution-option-item--type-range .substitution-option-item__count{padding-right:0}.substitution-option-item__image{width:50px;height:50px}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .substitution-option-item__image:not(:first-child){margin-left:5px}:host([dir=\"rtl\"]) .substitution-option-item__image:not(:first-child){margin-right:5px}}:host(:not([dir=\"rtl\"])) .substitution-option-item__body{margin-left:15px}:host([dir=\"rtl\"]) .substitution-option-item__body{margin-right:15px}.substitution-option-item__description{font-size:0.875rem;line-height:1.25rem;color:#333333;margin:0}.substitution-option-item__description .highlight-naming{font-weight:400}.substitution-option-item__description .highlight-naming .accent{font-weight:700}@media screen and (min-width: 980px){.substitution-option-item:active .substitution-option-item__description,.substitution-option-item:hover .substitution-option-item__description{text-decoration:underline}}.substitution-option-item__name{font-size:0.625rem;line-height:1.25rem;color:#626469}.substitution-option-item--type-range .substitution-option-item__name{font-weight:bold;font-size:0.875rem;color:#333333}";

let SubstitutionsOptionItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.linkClickHandler = (event) => {
      if (isAppRoutingEnabled()) {
        event.preventDefault();
        navigateWithRouter(this.route, event.currentTarget);
      }
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(this.url);
      this.route = new PesRoute({ page: pageType, pageId });
      this.url = this.route.url;
    }
  }
  render() {
    if (this.isExternalConsumer && this.externalUrlConfig[ExternalUrlConfigAction.SUBSTITUTION]) {
      this.url = generateExternalURL(ExternalUrlConfigAction.SUBSTITUTION, this.externalUrlConfig, {
        repositoryId: this.externalSubstitutionKey,
      });
    }
    if (this.type === 'range') {
      return (h("a", { href: this.url, class: "substitution-option-item substitution-option-item--type-range", onClick: this.linkClickHandler }, h("img", { src: this.imageURL, alt: this.imageTitle, class: "substitution-option-item__image", loading: "lazy" }), h("div", { class: "substitution-option-item__body" }, h("div", { class: "substitution-option-item__name", innerHTML: this.header }), h("div", { class: "substitution-option-item__description", innerHTML: this.description }), this.quantityLabel && (h("div", { class: "substitution-option-item__count" }, this.quantityLabel)))));
    }
    return (h("a", { href: this.url, class: "substitution-option-item", onClick: this.linkClickHandler }, h("div", { class: "substitution-option-item__count" }, this.quantityLabel), h("img", { src: this.imageURL, alt: this.imageTitle, class: "substitution-option-item__image", loading: "lazy" }), h("div", { class: "substitution-option-item__body" }, h("div", { class: "substitution-option-item__description", innerHTML: this.description }), h("div", { class: "substitution-option-item__name", innerHTML: this.header }))));
  }
  get el() { return getElement(this); }
};
SubstitutionsOptionItem.style = optionItemCss;

const isSubstitutionsData = (data) => {
  return 'substitutions' in data;
};
let PesSubstitutionsOrAlternatives = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    var _a, _b, _c, _d;
    if (!((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.substitutions) === null || _b === void 0 ? void 0 : _b.length)
      && !((_d = (_c = this.data) === null || _c === void 0 ? void 0 : _c.products) === null || _d === void 0 ? void 0 : _d.length)) {
      return null;
    }
    const { recommendedReplacementsLabel, title, addToMyProductsLabel, removeFromMyProductsLabel, cartTransferEnabled, } = this.data;
    if (isSubstitutionsData(this.data)) {
      const { viewMoreLabel, viewLessLabel, addGroupToMyProductsLabel, removeGroupFromMyProductsLabel, orLabel, substitutions, productsNumberLabel, } = this.data;
      return (h("pes-substitutions", { header: recommendedReplacementsLabel, showMoreLabel: viewMoreLabel, showLessLabel: viewLessLabel, addToCartProductLabel: addToMyProductsLabel, removeFromCartProductLabel: removeFromMyProductsLabel, addToCartGroupLabel: addGroupToMyProductsLabel, removeFromCartGroupLabel: removeGroupFromMyProductsLabel, cartTransferEnabled: cartTransferEnabled, orLabel: orLabel, substitutions: substitutions, productsNumberLabel: productsNumberLabel, productId: this.productId, class: "subsection__item", hideCtas: this.isApc, isExternalConsumer: this.isExternalConsumer, externalUrlConfig: this.externalUrlConfig }));
    }
    const { products } = this.data;
    return (h("pes-alternatives", { header: title, addToCartProductLabel: addToMyProductsLabel, removeFromCartProductLabel: removeFromMyProductsLabel, cartTransferEnabled: cartTransferEnabled, alternatives: products, productId: this.productId, class: "subsection__item", hideCtas: this.isApc }));
  }
};

const showMoreLessButtonCss = ":host{display:block}.show-more-less-button{padding:0;background-color:transparent;border:none;outline:none;cursor:pointer;font-family:inherit;width:100%;min-height:40px;text-align:center;color:#42b4e6;display:flex;justify-content:center;align-items:center;font-size:0.875rem;line-height:1.25rem}@media screen and (min-width: 980px){.show-more-less-button:focus .show-more-less-button__text,.show-more-less-button:hover .show-more-less-button__text{text-decoration:underline}}";

let SubstitutionsShowMoreLessButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.showMoreLessClicked = createEvent(this, "showMoreLessClicked", 7);
    this.handleClick = () => {
      this.showMoreLessClicked.emit();
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("button", { onClick: this.handleClick, class: "show-more-less-button", type: "button" }, h("span", { class: "show-more-less-button__text" }, this.isExpanded ? this.showLessLabel : this.showMoreLabel), h("se-icon", { size: pesIconSizes.MICRO, mirror: this.isExpanded ? pesIconMirrorDirection.VERTICAL : undefined }, "arrow2_down")));
  }
  get el() { return getElement(this); }
};
SubstitutionsShowMoreLessButton.style = showMoreLessButtonCss;

const sustainabilityOverviewCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.link{text-decoration:none;outline:none;color:#42b4e6}.link:hover{text-decoration:underline}.link:focus{outline:auto}.icon-enabled{width:20px;height:20px;align-self:flex-start;border-radius:50%;background-color:#3dcd58}ul{list-style:none}.block-body{align-items:center}.sustainability-overview{display:flex;flex-direction:column}.sustainability-title{border-top:1px solid #e7e6e6;padding-top:24px;font-weight:700;font-size:14px;margin-bottom:18px}.sustainability-content{display:flex;flex-direction:row}@media screen and (max-width: 979px){.sustainability-content{flex-direction:column;align-items:center}}.sustainability-details{border-top:none}@media screen and (max-width: 979px){.sustainability-details{padding:0 6px}}.icons-container{display:flex;flex:0 0 auto;margin-top:10px}:host(:not([dir=\"rtl\"])) .icons-container{margin-right:17px}:host([dir=\"rtl\"]) .icons-container{margin-left:17px}@media screen and (max-width: 979px){.icons-container{margin-top:0}:host(:not([dir=\"rtl\"])) .icons-container{margin-right:0}:host([dir=\"rtl\"]) .icons-container{margin-left:0}.icons-container:not(:only-child){margin-bottom:20px}}:host(:not([dir=\"rtl\"])) .energy-star{margin-right:10px}:host([dir=\"rtl\"]) .energy-star{margin-left:10px}.green-premium{cursor:pointer}.overview-container{flex:1;display:grid;row-gap:0;max-width:426px;grid-template-columns:repeat(4, 1fr)}.single-row{transition:0.3s ease;row-gap:0}.multiple-rows{transition:0.3s ease;row-gap:24px}.large-grid{grid-template-columns:repeat(3, 1fr)}.small-grid{grid-template-columns:repeat(4, 1fr)}.details-container{margin-top:10px;display:grid;row-gap:24px;grid-template-columns:repeat(auto-fill, minmax(93px, 142px))}.small-details{grid-template-columns:repeat(auto-fill, 93px);column-gap:10px}.large-details{grid-template-columns:repeat(auto-fill, 142px)}.sustainability-pillars-carousel{margin-top:20px}.large-grid-item{width:142px;--se-carousel-item-width:142px}.small-grid-item{width:93px;--se-carousel-item-width:93px}.show-more-container{margin-top:7px;display:flex;flex-direction:column;align-items:center;position:relative}:host(:not([dir=\"rtl\"])) .show-more-container{margin-left:20px}:host([dir=\"rtl\"]) .show-more-container{margin-right:20px}.show-more-icon{display:inline-block;width:38px;height:38px;border:1px solid #e7e6e6;border-radius:10px;background-size:18px;background-repeat:no-repeat;background-position:center;cursor:pointer}.closed{background-image:url(\"data:image/svg+xml,%3Csvg width='19' height='10' viewBox='0 0 19 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.304199 1.1375C0.116699 0.95 0.116699 0.621875 0.304199 0.434375C0.397949 0.340625 0.538574 0.29375 0.655762 0.29375C0.796387 0.29375 0.913574 0.340625 1.00732 0.434375L9.13076 8.55078L17.3198 0.394531C17.4136 0.300781 17.5308 0.253906 17.6714 0.253906C17.7886 0.253906 17.9292 0.300781 18.0229 0.394531C18.2104 0.582031 18.2104 0.910156 18.0229 1.09766L9.50576 9.60547C9.29482 9.79297 8.99014 9.79297 8.7792 9.60547L0.304199 1.1375Z' fill='%23626469'/%3E%3C/svg%3E\")}.opened{background-image:url(\"data:image/svg+xml,%3Csvg width='19' height='10' viewBox='0 0 19 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.8477 9.07539C19.0352 9.26289 19.0352 9.59102 18.8477 9.77852C18.7539 9.87227 18.6133 9.91914 18.4961 9.91914C18.3555 9.91914 18.2383 9.87227 18.1445 9.77852L10.0211 1.66211L1.83203 9.81836C1.73828 9.91211 1.62109 9.95898 1.48047 9.95898C1.36328 9.95898 1.22266 9.91211 1.12891 9.81836C0.941406 9.63086 0.941406 9.30273 1.12891 9.11523L9.64609 0.607422C9.85703 0.419922 10.1617 0.419922 10.3727 0.607422L18.8477 9.07539Z' fill='%23626469'/%3E%3C/svg%3E\")}.show-more-label{font-size:12px;line-height:1.5;position:absolute;top:49px;display:block;font-weight:normal;color:#333333;text-align:center}.icon-arrow{padding:7px 8px 8px;width:10px;height:10px;background-repeat:no-repeat;background-size:100%}:host(:not([dir=\"rtl\"])) .icon-arrow{margin-left:2px}:host([dir=\"rtl\"]) .icon-arrow{margin-right:2px}.icon-arrow-down{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath fill='%23626469' d='M657 432c8 8 8 22 0 30L527 592c-5 4-10 6-15 6-6 0-11-2-16-6L366 462c-8-8-8-22 0-30 9-8 22-8 30 0l116 115 115-115c8-8 21-8 30 0z'/%3E%3C/svg%3E\")}.icon-arrow-up{display:block;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath fill='%23626469' d='M657 562c8 8 8 22 0 30-4 4-10 6-15 6-6 0-11-2-15-6L512 477 396 592c-4 4-9 6-15 6-5 0-11-2-15-6-8-8-8-22 0-30l130-130c9-8 22-8 31 0z'/%3E%3C/svg%3E\")}";

let SustainabilityOverview = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.scrollToSustainability = createEvent(this, "scrollToSustainability", 7);
    this.withAnchorLinks = false;
    this.isSustainabilityDetails = false;
    this.isBrowser = isBrowser();
    this.isMobile = isMobile();
    this.isLongWordPresent = false;
    this.isShowMoreRequired = false;
    this.isShowMoreOpened = false;
    this.scrollToSustainabilitySector = () => {
      this.scrollToSustainability.emit();
    };
    this.setPillarCarouselRef = (el) => {
      this.pillarCarouselEl = el;
    };
  }
  componentWillLoad() {
    const longWordThresholdPerWF8 = 16;
    this.isLongWordPresent = checkForLongWordInString(this.getSustainabilityPillars(), longWordThresholdPerWF8);
  }
  componentDidLoad() {
    if (isMobile()) {
      const pillars = this.getSustainabilityPillars();
      const isLowQuantityOfMobilePillars = (this.isLongWordPresent && pillars.length < 3) || pillars.length < 4;
      if (isLowQuantityOfMobilePillars) {
        const innerContent = this.pillarCarouselEl.shadowRoot.querySelector('.content');
        innerContent.style.justifyContent = 'center';
      }
    }
  }
  renderEnergyStarLogo() {
    var _a, _b, _c;
    return (h("div", null, h("a", { href: (_a = this.sustainability.energyStarLogo) === null || _a === void 0 ? void 0 : _a.externalUrl, target: "_blank" }, h("img", { class: "energy-star", width: "47", height: "49", src: (_b = this.sustainability.energyStarLogo) === null || _b === void 0 ? void 0 : _b.absoluteUrl, alt: (_c = this.sustainability.energyStarLogo) === null || _c === void 0 ? void 0 : _c.alt }))));
  }
  renderGreenPremiumLogo() {
    var _a, _b;
    return (h("div", { onClick: this.scrollToSustainabilitySector }, h("img", { class: "green-premium", width: "127", height: "48", src: (_a = this.sustainability.greenPremiumLogo) === null || _a === void 0 ? void 0 : _a.absoluteUrl, alt: (_b = this.sustainability.greenPremiumLogo) === null || _b === void 0 ? void 0 : _b.alt })));
  }
  renderSustainabilityLogos() {
    var _a, _b;
    return (h("div", { class: "icons-container" }, ((_a = this.sustainability.energyStarLogo) === null || _a === void 0 ? void 0 : _a.absoluteUrl) ? this.renderEnergyStarLogo() : '', ((_b = this.sustainability.greenPremiumLogo) === null || _b === void 0 ? void 0 : _b.absoluteUrl) ? this.renderGreenPremiumLogo() : ''));
  }
  getSustainabilityPillars() {
    var _a;
    return ((_a = this === null || this === void 0 ? void 0 : this.sustainability) === null || _a === void 0 ? void 0 : _a.sustainabilityPillar) || [];
  }
  renderSustainabilityPillar(data) {
    return (h("pes-sustainability-pillar", { data: data, withAnchorLinks: this.withAnchorLinks, isLongWordPresent: this.isLongWordPresent }));
  }
  renderMobileSustainabilityPillars() {
    return (h("se-carousel", { class: "sustainability-pillars-carousel", arrowsOverlay: true, ref: this.setPillarCarouselRef }, this.getSustainabilityPillars().map((pillar) => {
      return (h("se-carousel-item", { class: `${this.isLongWordPresent ? 'large-grid-item' : 'small-grid-item'}` }, this.renderSustainabilityPillar(pillar)));
    })));
  }
  renderDesktopSustainabilityPillars() {
    let sustainabilityPillars = this.getSustainabilityPillars();
    if (!this.isSustainabilityDetails) {
      const { isShowMoreRequired, pillarsPerRow } = checkForShowMore(sustainabilityPillars, this.isLongWordPresent);
      if (isShowMoreRequired) {
        this.isShowMoreRequired = isShowMoreRequired;
        const visiblePillars = sustainabilityPillars.slice(0, pillarsPerRow);
        const hiddenPillars = sustainabilityPillars.slice(pillarsPerRow).map((hiddenPillar) => {
          return Object.assign(Object.assign({}, hiddenPillar), { isHidden: !this.isShowMoreOpened });
        });
        sustainabilityPillars = [...visiblePillars, ...hiddenPillars];
      }
    }
    return (h("div", { class: `${this.isSustainabilityDetails
        ? `details-container ${this.isLongWordPresent ? 'large-details' : 'small-details'}`
        : `overview-container ${this.isLongWordPresent ? 'large-grid' : 'small-grid'} ${this.isShowMoreOpened ? 'multiple-rows' : 'single-row'}`}` }, sustainabilityPillars.map((pillar) => this.renderSustainabilityPillar(pillar))));
  }
  toggleShowMore() {
    this.isShowMoreOpened = !this.isShowMoreOpened;
  }
  renderShowMore() {
    return (h("div", { class: "show-more-container", onClick: () => this.toggleShowMore() }, h("div", { class: `show-more-icon ${this.isShowMoreOpened ? 'opened' : 'closed'}` }), h("div", { class: "show-more-label" }, this.isShowMoreOpened ? this.sustainability.closeLabel : this.sustainability.seeAllLabel)));
  }
  renderDesktopView() {
    if (this.isSustainabilityDetails) {
      return h("div", { class: "sustainability-details" }, this.renderDesktopSustainabilityPillars());
    }
    return (h("div", null, h("div", { class: "sustainability-overview" }, h("div", { class: "sustainability-title" }, this.sustainability.sustainabilityLabel), h("div", { class: "sustainability-content" }, this.renderSustainabilityLogos(), this.renderDesktopSustainabilityPillars(), this.isShowMoreRequired && this.renderShowMore()))));
  }
  renderMobileView() {
    if (this.isSustainabilityDetails) {
      return h("div", null, this.renderMobileSustainabilityPillars());
    }
    return (h("div", null, h("div", { class: "sustainability-overview" }, h("div", { class: "sustainability-title" }, this.sustainability.sustainabilityLabel), h("div", { class: "sustainability-content" }, this.renderSustainabilityLogos())), this.renderMobileSustainabilityPillars()));
  }
  render() {
    if (this.sustainability) {
      return (h(Host, null, (!this.isBrowser || !this.isMobile) && this.renderDesktopView(), this.isBrowser && this.isMobile && this.renderMobileView()));
    }
  }
};
SustainabilityOverview.style = sustainabilityOverviewCss;

const priceSpiderCss = "@media screen and (max-width: 979px){.ps-widget__wrapper{display:flex;justify-content:center;padding:0 5px}}.ps-widget__block{max-width:328px;height:264px;background-color:#ffffff;padding:8px 0;position:relative;width:100%}@media screen and (max-width: 979px){.ps-widget__block{margin:0 auto}}.ps-widget__partners{position:relative}.ps_widget__preloader{display:flex;height:100%;margin:10px;justify-content:center;align-items:center}.ps_widget__preloader::before{content:\" \";border:3px solid #3dcd58;border-top-color:transparent;border-radius:50%;width:30px;height:30px;animation:spin 2s linear infinite}.ps_widget__preloader_hidden{display:none}.ps_widget__container{overflow:hidden;height:0}.ps_widget__container_visible{height:auto;overflow:visible}.our_partners{margin:9px 20px 16px 0;display:flex;justify-content:space-between}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .our_partners{margin:9px 20px 16px 16px}:host([dir=\"rtl\"]) .our_partners{margin:9px 16px 16px 20px}}.our_partners__label{flex-grow:1;width:93px;height:20px;font-weight:bold;text-align:start;text-transform:none;font-size:rem-calc(14);line-height:rem-calc(20);color:#333333;letter-spacing:0}.our_partners__link{color:#42b4e6;cursor:pointer;border:none;outline:none;background-color:transparent;padding:0;height:20px;text-align:start;text-transform:none;font-display:swap;font-size:rem-calc(14);line-height:rem-calc(20)}.our_partners__icon{margin-left:5px;display:inline-block;width:7px;height:7px;border:1px solid #42b4e6;border-radius:2px;align-self:center}.our_partners__icon::after{content:\"\";width:7px;height:7px;display:block;border:1px solid #42b4e6;border-radius:2px;position:relative;bottom:3px;background-color:#ffffff}:host(:not([dir=\"rtl\"])) .our_partners__icon::after{right:3px}:host([dir=\"rtl\"]) .our_partners__icon::after{left:3px}.ps-online-buy-button.available.ps-online-seller-button,.ps-online-buy-button.unavailable.ps-online-seller-button{width:120px;height:40px;border-style:solid;border-width:1px;border-color:#42b4e6;box-sizing:border-box;border:1px solid #42b4e6;border-radius:2px}@media screen and (max-width: 719px){.ps-online-buy-button.available.ps-online-seller-button,.ps-online-buy-button.unavailable.ps-online-seller-button{width:88px}}.ps-container .ps-mini .ps-online-seller-select>div>div>div>span>span.ps-stock-status,.ps-mini .ps-online-seller-select>div>div>div>small,div[data-online-store]>div>div>div>small,div.ps-online-seller>div>div>div>small,button.ps-online-buy-button:hover.available>span,button.ps-online-buy-button:hover.unavailable>span,div>button.ps-online-buy-button.available>small,div>button.ps-online-buy-button.unavailable>small,.ps-container .ps-header-title,.ps-wtb-container .ps-footer-panel .ps-copyright,.ps-wtb-container .ps-footer-panel .ps-copyright a,.ps-header-content .ps-product-details .ps-product-details-title,.ps-header-content .ps-product-details .ps-part-number,.ps-column-headers .ps-online-tab-label,.ps-column-headers .ps-local-tab-label,.ps-map-control .ps-input-holder .ps-map-location-textbox,.ps-online-section .ps-online-seller-select .ps-online-availability-cell,.ps-online-section .ps-online-seller-select .ps-online-availability-cell button.ps-online-buy-button{font-family:\"ArialRoundedMTforSE_Latin\", Arial, \"Helvetica Neue\", Helvetica, sans-serif;font-display:swap}div>button.ps-online-buy-button.available>small,div>button.ps-online-buy-button.unavailable>small{font-size:16px;line-height:24px;font-weight:normal}@media screen and (max-width: 979px){div.ps-mini div.ps-online-tab{padding:0}}div.ps-mini div.ps-online-tab>div.ps-online-sellers{max-height:228px !important;padding:0 !important}div.ps-mini div.ps-online-tab>div.ps-online-sellers ::-webkit-scrollbar{-webkit-appearance:none;width:4px !important}div.ps-mini div.ps-online-seller-select>div>div{padding:4px 0;display:flex;align-items:center}div.ps-mini div.ps-online-seller-select>div>div>div{width:auto}div.ps-mini div.ps-online-seller-select>div>div>div>span>span.ps-stock-status.available{width:55px;height:20px;background:rgba(61, 205, 88, 0.1);border-radius:2px;display:flex;justify-content:center;align-items:center}div.ps-mini div.ps-online-seller-select>div>div>div:first-child{flex-grow:1}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) div.ps-mini div.ps-online-seller-select>div>div>div:first-child{padding-left:16px}:host([dir=\"rtl\"]) div.ps-mini div.ps-online-seller-select>div>div>div:first-child{padding-right:16px}}div.ps-mini div.ps-online-seller-select>div>div>div:nth-child(2){width:auto;padding-right:30px}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) div.ps-mini div.ps-online-seller-select>div>div>div:nth-child(3){padding-right:4px}:host([dir=\"rtl\"]) div.ps-mini div.ps-online-seller-select>div>div>div:nth-child(3){padding-left:4px}}:host(:not([dir=\"rtl\"])) div.ps-mini div.ps-online-seller-select,:host(:not([dir=\"rtl\"])) div.ps-online-seller{margin:0px 4px 0 0}:host([dir=\"rtl\"]) div.ps-mini div.ps-online-seller-select,:host([dir=\"rtl\"]) div.ps-online-seller{margin:0px 0 0 4px}div.ps-mini div.ps-online-tab ::-webkit-scrollbar{-webkit-appearance:none;width:4px}div.ps-mini div.ps-online-tab ::-webkit-scrollbar-thumb{min-height:40px;width:4px;border-radius:8px;background-clip:content-box;background:#cbcbcb;border:none}div.ps-mini div.ps-online-tab ::-webkit-scrollbar-thumb:hover{background:#cbcbcb}div.ps-mini div.ps-online-tab ::-webkit-scrollbar-track-piece{width:4px;border-radius:8px;background:#f7f7f7;box-sizing:border-box}div.ps-mini div.ps-online-tab ::-webkit-scrollbar-corner{background:transparent}div.ps-mini div.ps-online-tab ::-webkit-scrollbar-thumb:hover{background:rgba(102, 102, 102, 0.75)}.ps-container .ps-lightbox-close{width:20px;height:20px;top:25px}.ps-container .ps-header-title{height:60px;background:#3dcd58;font-size:26px;color:#ffffff;padding:15px 0 0 40px;font-weight:bold}@media screen and (max-width: 719px){.ps-container .ps-header-title{padding:15px 0 0 16px;height:48px;font-size:18px}}.ps-wtb-container.ps-float-box .ps-header-container{height:90px;border:none}.ps-wtb-container.ps-float-box .ps-online-container{padding:210px 0 0 0}@media screen and (max-width: 719px){.ps-wtb-container.ps-float-box .ps-online-container .ps-no-results{width:auto}}@media screen and (max-width: 979px){.ps-wtb-container.ps-float-box .ps-online-container{background:#fafafa;padding:23px 0 0 0}}.ps-wtb-container.ps-float-box .ps-local-container{padding:250px 0 0 0}@media screen and (max-width: 979px){.ps-wtb-container.ps-float-box .ps-local-container{padding:0}}@media screen and (max-width: 979px){.ps-wtb-container.ps-float-box .ps-column-headers{flex-basis:50%;padding-left:0}}.ps-wtb-container.ps-float-box .ps-column-headers label.ps-online-tab-label,.ps-wtb-container.ps-float-box .ps-column-headers label.ps-local-tab-label{height:50px;margin:0 !important}.ps-header-container.ps-float-box.ps-header-has-product-details .ps-lightbox-close{top:-40px;width:20px;height:20px;background-color:#ffffff;border-radius:50%}.ps-header-container.ps-float-box.ps-header-has-product-details .ps-lightbox-close svg{width:8px;height:8px}@media screen and (max-width: 719px){.ps-header-container.ps-float-box.ps-header-has-product-details .ps-lightbox-close{top:-35px}}.ps-wtb-container .ps-header-content{padding:0 0 0 36px;margin-top:24px;height:auto}@media screen and (max-width: 719px){.ps-wtb-container .ps-header-content{display:flex;margin-top:16px;max-height:77px}}.ps-wtb-container .ps-column-headers{border:none;height:24px;padding:0;margin-top:32px;padding-left:36px}.ps-wtb-container .ps-map-control{top:155px;right:175px}@media screen and (max-width: 719px){.ps-wtb-container .ps-map-control{top:20px;right:0;display:flex;justify-content:center}}@media screen and (min-width: 720px) and (max-width: 980px){.ps-wtb-container .ps-map-control{top:120px;right:40px}}.ps-wtb-container .ps-footer-panel{background:#ffffff}.ps-wtb-container .ps-footer-panel .ps-copyright{text-align:left;text-transform:none;font-size:14px;color:#626469}.ps-wtb-container .ps-footer-panel .ps-copyright a{text-align:left;text-transform:none;font-size:14px;color:#626469}.ps-header-content .ps-product-details{padding:0 0 0 24px;display:flex;flex-direction:column}@media screen and (max-width: 979px){.ps-header-content .ps-product-details{padding:0 10px}}.ps-header-content .ps-product-details .ps-product-details-title{clear:both;width:440px;font-weight:normal;text-align:left;text-transform:none;font-size:14px;color:#333333;line-height:20px}@media screen and (max-width: 719px){.ps-header-content .ps-product-details .ps-product-details-title{font-size:12px;line-height:16px}}.ps-header-content .ps-product-details .ps-part-number{clear:both;width:404px;text-align:left;text-transform:none;font-weight:bold;font-size:16px;color:#333333;line-height:25px}@media screen and (max-width: 719px){.ps-header-content .ps-product-details .ps-part-number{font-size:14px}}.ps-header-content .ps-product-details-image{width:72px;height:72px}.ps-header-content .ps-product-details-image img{height:72px;max-height:72px;width:72px;min-width:72px}.ps-header-logo.ps-float-box{display:none}.ps-column-headers .ps-online-tab-label{border:none;width:435px}.ps-column-headers .ps-online-tab-label,.ps-column-headers .ps-local-tab-label{text-transform:none;height:24px;text-align:left;text-transform:none;font-size:14px;color:#333333;line-height:24px;font-weight:inherit}@media screen and (max-width: 979px){.ps-column-headers .ps-online-tab-label,.ps-column-headers .ps-local-tab-label{margin:0px 3px;width:50%}}.ps-online-container .ps-online-section{border:none}.ps-online-container .ps-online-section .ps-online-sellers{background:#ffffff;border-right:none;padding:0}@media screen and (min-width: 980px){.ps-online-container .ps-online-section .ps-online-sellers .ps-online-seller-listings{padding:5px 0 0 36px}}@media screen and (max-width: 979px){.ps-online-container .ps-online-section .ps-online-sellers .ps-online-seller-listings{background:#fafafa;padding:5px 0 0 0}}.ps-local-container .ps-local-container-container{background:#ffffff}@media screen and (max-width: 719px){.ps-local-container .ps-local-container-container{background:#fafafa}}.ps-map-control .ps-input-holder{height:30px;width:324px}.ps-map-control .ps-input-holder .ps-map-location-textbox{height:30px;text-align:left;text-transform:none;font-size:14px;color:#9fa0a4;line-height:20px;background:#ffffff;box-sizing:border-box;border:1px solid #9fa0a4}.ps-map-control .ps-input-holder .ps-mag-icon{height:30px;width:70px;padding:5px 26px 0 0;background:#42b4e6}.ps-online-section .ps-online-seller-select{border:none;height:40px;margin:8px 0;display:flex;width:100%}.ps-online-section .ps-online-seller-select:hover{box-shadow:none}@media screen and (max-width: 979px){.ps-online-section .ps-online-seller-select{background:#fafafa;padding-right:16px;box-shadow:none}}.ps-online-section .ps-online-seller-select:first-child{margin:0 0 8px 0}@media screen and (max-width: 719px){.ps-online-section .ps-online-seller-select .ps-online-seller-listing-cell{width:120px;padding:0;margin:0}}.ps-online-section .ps-online-seller-select .ps-online-seller-cell{justify-content:flex-start;flex-grow:1}@media screen and (max-width: 719px){.ps-online-section .ps-online-seller-select .ps-online-seller-cell{padding-left:16px}}.ps-online-section .ps-online-seller-select .ps-online-seller-cell img{max-width:72px;max-height:40px}.ps-online-section .ps-online-seller-select .ps-online-price-cell{padding-right:16px;align-items:flex-end;text-align:right}@media screen and (max-width: 719px){.ps-online-section .ps-online-seller-select .ps-online-price-cell{width:auto;padding-right:16px;flex-grow:1}}@media screen and (min-width: 720px) and (max-width: 980px){.ps-online-section .ps-online-seller-select .ps-online-price-cell{align-items:center}}.ps-online-section .ps-online-seller-select .ps-online-availability-cell{justify-content:center;text-transform:none;font-size:12px}@media screen and (min-width: 720px) and (max-width: 980px){.ps-online-section .ps-online-seller-select .ps-online-availability-cell{justify-content:flex-end}}.ps-online-section .ps-online-seller-select .ps-online-availability-cell .ps-in-stock{width:55px;height:20px;background:rgba(61, 205, 88, 0.1);border-radius:2px;color:#3dcd58;line-height:20px;text-align:center}.ps-online-section .ps-online-seller-select .ps-online-availability-cell svg{display:none}.ps-online-section .ps-online-seller-select .ps-online-buy-cell{justify-content:flex-end}@media screen and (min-width: 980px){.ps-online-section .ps-online-seller-select .ps-online-buy-cell{padding:0 10px 0 0}}@media screen and (max-width: 719px){.ps-online-section .ps-online-seller-select .ps-online-buy-cell{padding:0}}.ps-online-section .ps-online-seller-select .ps-online-buy-cell button.ps-online-buy-button{min-width:120px;border-style:solid;border-width:1px;border-color:#42b4e6;box-sizing:border-box;border:1px solid #42b4e6;border-radius:2px;background:#ffffff;text-transform:none;font-size:16px;color:#42b4e6;line-height:24px}@media screen and (max-width: 719px){.ps-online-section .ps-online-seller-select .ps-online-buy-cell button.ps-online-buy-button{background:#fafafa}}.ps-container.ps-lightbox{display:none}@media screen and (max-width: 979px){.ps-container.ps-lightbox .ps-wtb-container .ps-column-headers label.ps-online-tab-label,.ps-container.ps-lightbox .ps-wtb-container .ps-column-headers label.ps-local-tab-label{background:#ffffff;color:#626469;font-size:16px;line-height:20px;border:1px solid #a1a1a1}.ps-container.ps-lightbox .ps-wtb-container .ps-column-headers label.ps-online-tab-label.selected,.ps-container.ps-lightbox .ps-wtb-container .ps-column-headers label.ps-local-tab-label.selected{background:#fafafa;color:#333333;border-top:2px solid #3dcd58;border-bottom:none}.ps-container.ps-lightbox .ps-wtb-container .ps-column-headers label.ps-online-tab-label.selected{border-left:1px solid #a1a1a1}.ps-container.ps-lightbox .ps-wtb-container .ps-column-headers label.ps-local-tab-label.selected{border-right:1px solid #a1a1a1}}@media screen and (max-width: 979px){.ps-container.ps-lightbox .ps-wtb-container{display:flex;flex-direction:column}.ps-container.ps-lightbox .ps-wtb-container .ps-product-details .ps-product-details-title{width:auto}.ps-container.ps-lightbox .ps-wtb-container .ps-product-details .ps-part-number{width:auto}.ps-container.ps-lightbox .ps-wtb-container .ps-column-headers{margin-top:75px;padding:0}}.ps-container.ps-lightbox ::-webkit-scrollbar{-webkit-appearance:none;width:4px}.ps-container.ps-lightbox ::-webkit-scrollbar-thumb{min-height:40px;width:4px;border-radius:8px;background-clip:content-box;background:#3dcd58;border:none}.ps-container.ps-lightbox ::-webkit-scrollbar-thumb:hover{background:#3dcd58}.ps-container.ps-lightbox ::-webkit-scrollbar-track-piece{width:4px;border-radius:8px;background:#f7f7f7;box-sizing:border-box}.ps-container.ps-lightbox ::-webkit-scrollbar-corner{background-color:transparent}.ps-lightbox-show{display:block}#ps-lightbox-background{display:none}";

let PriceSpider = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.priceSpiderError = createEvent(this, "priceSpiderError", 7);
    this.ourPartnersLabel = 'Online stores';
    this.showAllLabel = 'Show all';
    this.modalTitle = 'Choose your store';
    this.isError = false;
    this.removeWidgetBlock = () => {
      const element = document.querySelector('.ps-widget__block');
      if (element) {
        element.parentNode.removeChild(element);
      }
    };
    this.parseWidget = (element) => {
      const isError = element.classList.contains('ps-no-sku') || document.querySelector('.ps-no-results') !== null;
      if (isError) {
        this.removeWidgetBlock();
        this.isError = true;
      }
    };
    this.addClickEventShowAll = () => {
      document.querySelector('.our_partners__link').addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementById('ps-show-all-initial').click();
      });
    };
    this.startPreloaderObserver = (config) => {
      const observedElement = document.getElementById('ps-show-all-initial');
      const preloaderObserver = new MutationObserver(() => {
        this.parseWidget(observedElement);
        preloaderObserver.disconnect();
      });
      preloaderObserver.observe(observedElement, config);
    };
    this.startMutationListening = () => {
      try {
        const timerID = setTimeout(this.removeWidgetBlock, 10000);
        const config = { childList: true };
        if (!this.priceSpiderId) {
          this.startPreloaderObserver(config);
        }
        const partnersObserver = new MutationObserver(() => {
          var _a;
          clearTimeout(timerID);
          const partnersWidget = document.querySelector('.ps-widget__partners');
          if (!partnersWidget) {
            return true;
          }
          const partnersWidgetContainer = partnersWidget.parentElement;
          partnersWidgetContainer.classList.add('ps_widget__container_visible');
          (_a = partnersWidgetContainer.nextElementSibling) === null || _a === void 0 ? void 0 : _a.classList.add('ps_widget__preloader_hidden');
          const noResultsElements = partnersWidget.querySelector('.ps-no-results:not(.hidden)');
          if (noResultsElements) {
            this.removeWidgetBlock();
            this.isError = true;
            return true;
          }
          if (isAnalyticsEnabled()) {
            send(viewExternalPartnerLink, {
              external_partner_name: (this.priceSpiderId && "B2B price spider widget") || "B2C price spider widget",
              external_partner_url: this.priceSpiderId,
            });
          }
          if (!this.priceSpiderId) {
            this.addClickEventShowAll();
          }
          return partnersObserver.disconnect();
        });
        partnersObserver.observe(document.querySelector('.ps-widget__partners'), config);
        return true;
      }
      catch (error) {
        return false;
      }
    };
    this.init = () => {
      var _a, _b, _c, _d;
      const psWidgetBlock = document.querySelector('.ps-widget__block');
      if (psWidgetBlock === null) {
        return;
      }
      const customerType = getUserSessionLoggedInValue();
      this.priceSpiderId = this.availableWidgets[customerType];
      if (this.priceSpiderId) {
        this.updateMetaTags(this.priceSpiderId);
      }
      else if ((_a = this.availableWidgets) === null || _a === void 0 ? void 0 : _a.Default) {
        this.updateMetaTags((_b = this.availableWidgets) === null || _b === void 0 ? void 0 : _b.Default);
      }
      else if ((_c = this.availableWidgets) === null || _c === void 0 ? void 0 : _c.public) {
        this.updateMetaTags((_d = this.availableWidgets) === null || _d === void 0 ? void 0 : _d.public);
      }
      const script = document.createElement('script');
      script.src = '//cdn.pricespider.com/1/lib/ps-widget.js';
      script.async = true;
      script.onload = this.startMutationListening;
      script.onerror = () => {
        this.removeWidgetBlock();
        this.isError = true;
      };
      document.head.appendChild(script);
    };
  }
  notifySubscribers() {
    this.priceSpiderError.emit();
  }
  createPSMetaTag(name) {
    const metaTag = document.createElement('meta');
    metaTag.setAttribute('name', `ps-${name}`);
    document.head.appendChild(metaTag);
    return metaTag;
  }
  updateMetaTags(psKeyValue) {
    let metaPSKey = document.querySelector('meta[name="ps-key"]');
    if (!metaPSKey) {
      metaPSKey = this.createPSMetaTag('key');
    }
    metaPSKey.content = psKeyValue;
  }
  watchPriceSpiderModal() {
    if (this.priceSpiderId || !isBrowser())
      return;
    const observedElement = document.querySelector('body');
    const observer = new MutationObserver(() => {
      const container = observedElement.querySelector('.ps-container.ps-lightbox');
      if (container) {
        this.modalObserver = new MutationObserver((mutations) => {
          mutations.forEach(({ target }) => {
            const elem = target;
            if (elem.classList.contains('ps-open')) {
              this.modifyModal(container);
            }
          });
        });
        const config1 = { attributeFilter: ['class'] };
        this.modalObserver.observe(container, config1);
        this.modifyModal(container);
        observer.disconnect();
      }
    });
    const config = { childList: true };
    observer.observe(observedElement, config);
  }
  showModal() {
    const psLightbox = document.querySelector('.ps-lightbox');
    const psLightboxBackground = document.querySelector('#ps-lightbox-background');
    if (psLightbox && psLightboxBackground) {
      setTimeout(() => {
        psLightbox.classList.add('ps-lightbox-show');
        psLightboxBackground.classList.add('ps-lightbox-show');
      }, 2000);
    }
  }
  modifyModal(psContainer) {
    const container = psContainer.querySelector('.ps-wtb-container');
    const header = psContainer.querySelector('.ps-header-title');
    if (container && !header) {
      this.showModal();
      const psHeader = document.createElement('div');
      psHeader.classList.add('ps-header-title');
      psHeader.innerText = this.modalTitle;
      container.prepend(psHeader);
    }
    const description = psContainer.querySelector('.ps-part-number');
    if (description) {
      description.innerText = this.productInfo.description;
    }
  }
  componentWillLoad() {
    this.init();
    this.watchPriceSpiderModal();
  }
  componentDidLoad() {
    this.startMutationListening();
  }
  disconnectedCallback() {
    if (this.modalObserver)
      this.modalObserver.disconnect();
  }
  render() {
    const isPublicPriceSpider = !this.priceSpiderId;
    return (!this.isError && (h("div", { class: "ps-widget__block" }, h("div", { class: "ps_widget__container ps_widget__container_parners" }, h("div", { class: "our_partners" }, h("div", { class: "our_partners__label" }, this.ourPartnersLabel), isPublicPriceSpider && (h("button", { class: "our_partners__link", "data-item-name": "Show-All" }, this.showAllLabel, h("span", { class: "our_partners__icon" })))), h("div", { class: "ps-widget ps-widget__partners", id: "ps-partners", "ps-config": isPublicPriceSpider ? "5bbf65a04a17ef05e8d8a0ae" : "65304d2283d990000e23ce8c", "ps-sku": this.productId })), isPublicPriceSpider && h("div", { class: "ps_widget__preloader" }), isPublicPriceSpider && (h("div", { class: "ps_widget__container" }, h("div", { class: "ps-widget", id: "ps-show-all-initial", "ps-config": "5900be5a8196951772ce423f", "ps-sku": this.productId }))))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "isError": ["notifySubscribers"]
  }; }
};
PriceSpider.style = priceSpiderCss;

export { AdditionalInfo as pes_additional_info, PesAlternatives as pes_alternatives, AlternativesItem as pes_alternatives_item, BulletPoints as pes_bullet_points, CtaAreaContainer as pes_cta_area_container, HighlightedCharacteristics as pes_highlighted_characteristics, LifeCycleInfo as pes_life_cycle_info, Links as pes_links, MainProductInfo as pes_main_product_info, MediaGalleryPopup as pes_media_gallery_popup, MediaGalleryZoom as pes_media_gallery_zoom, PesOfflineStores as pes_offline_stores, PesPdpProductVariants as pes_pdp_product_variants, PDPTabs as pes_pdp_tabs, Substitutions as pes_substitutions, SubstitutionsDelimiter as pes_substitutions_delimiter, SubstitutionsNotFound as pes_substitutions_not_found, SubstitutionsOptionItem as pes_substitutions_option_item, PesSubstitutionsOrAlternatives as pes_substitutions_or_alternatives, SubstitutionsShowMoreLessButton as pes_substitutions_show_more_less_button, SustainabilityOverview as pes_sustainability_overview, PriceSpider as price_spider };
